<template>
  <div id="draggable" v-if="auth.user.role == 'admin'" class="invisible">
    <div class="flex">
      <span>Songs Number:</span>
      <v-text-field type="number" v-model="settings.n" />
      <span>|</span>
      <v-text-field type="number" v-model="settings.songsNumber" />
    </div>
    <div class="flex">
      <span>Difficulty:</span>
      <v-text-field type="number" v-model="settings.difficulty" />
    </div>
    <div class="flex">
      <span>Watched:</span>
      <v-checkbox type="checkbox" v-model="settings.songsSelection" />
    </div>
    <div class="flex">
      <span>Admin access:</span>
      <v-checkbox type="checkbox" v-model="settings.access" />
    </div>
    <div class="flex">
      <span>Next song:</span>
      <v-autocomplete
        v-model="settings.nextSong"
        :items="animesSongs"
        chips
        closable-chips
        color="blue-grey-lighten-2"
        item-title="name"
        item-value="id"
        label="Select"
        auto-select-first
        multiple
      >
        <template v-slot:chip="{props, item}">
          <v-chip
            v-bind="props"
            :prepend-avatar="'https://api.baranimes.com/images/thumbnail/' + item?.raw?.poster"
            :text="item.raw.short + ' - ' + item?.raw?.song_type + ' ' + item?.raw?.song_number"
          ></v-chip>
        </template>

        <template v-slot:item="{props, item}">
          <v-list-item
            class="bg-second text-white"
            v-bind="props"
            :prepend-avatar="'https://api.baranimes.com/images/thumbnail/' + item?.raw?.poster"
            :title="item?.raw?.name"
            :subtitle="item?.raw?.song_type + ' ' + item?.raw?.song_number + ' - ' + item?.raw?.song_name"
          ></v-list-item>
        </template>
      </v-autocomplete>
    </div>
    <button @click="setSongsNumber">Set</button>
  </div>
  <v-dialog v-model="matchFound" persistent>
    <div class="flex flex-col text-center uppercase font-bold text-[8vw] tracking-tighter self-center items-center">
      <span class="match-found px-1">MATCH FOUND</span>
      <span class="text-[10vw] mt-[-4vw]">{{ countdown }}</span>
    </div>
  </v-dialog>
  <v-dialog max-width="550" v-model="confirmLeave">
    <div class="rounded-2xl bg-radiant text-white shadow-2xl">
      <v-card-title class="font-semibold text-2xl mt-2 text-center"> Quitter la salle ? </v-card-title>

      <v-card-actions class="justify-center">
        <v-btn text @click="confirmLeave = false"> Annuler </v-btn>
        <router-link to="/testhome" @click="confirmLeave = false">
          <v-btn color="#f54f67"> Quitter </v-btn>
        </router-link>
      </v-card-actions>
    </div>
  </v-dialog>
  <img
    src="https://api.baranimes.com/images/global/favicon_no_bg.webp"
    class="small pointer-events-none"
    id="logo"
    alt="Baranimes"
    draggable="false"
  />
  <div class="main relative" id="main">
    <!-- margin-top: 30px; -->
    <header class="header-section-main mt-[25px] lg:mt-[35px] duration-200">
      <div class="custom-container">
        <div class="header-section-inner">
          <div class="header-logo flex 2xl:block mt-[-10px]">
            <router-link to="/testhome">
              <img
                src="https://api.baranimes.com/images/global/favicon_no_bg.webp"
                draggable="false"
                class="cursor-scale small hover:scale-105 duration-300"
                alt="logo"
                id="home"
              />
            </router-link>
            <div
              class="flex items-center uppercase ml-[-10px] mt-[5px] absolute xl:ml-[50px] 2xl:ml-[-10px]"
              id="back"
              @click="preRetour()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer" width="60" height="40" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                  <path d="m13 19l-6-7l6-7" />
                  <path d="m17 19l-6-7l6-7" opacity=".5" />
                </g>
              </svg>
              <!-- margin-left: -15px; -->
              <span class="text-[15px] w-0 whitespace-nowrap ml-[-21px] cursor-pointer py-4 pr-[70px]">⬩ Retour</span>
            </div>
            <div class="banner-left-vertical-main hidden 2xl:flex" id="banner-left-vertical-main">
              <h6 class="ml-[21px]">BARANIMES</h6>
              <img
                draggable="false"
                src="https://www.yudiz.com/codepen/valorant-characters/gl-logo-first.svg"
                class="gl-logo-img"
              />
            </div>
          </div>

          <div class="header-menu block">
            <!-- display: flex;
    padding: 10px 0;
    margin-right: -45px;
    gap: 15px; -->
            <ul
              class="flex lg:gap-6 gap-3 mr-[-75px] pr-[30px] pt-[10px]"
              :class="{'xl:mr-[-50px]': auth.user.role == 'guest', 'xl:mr-0': auth.user.role != 'guest'}"
            >
              <router-link v-if="auth.user.role == 'admin'" to="/admin" class="flex items-center m-1">
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    class="text-[#f54f67]"
                  >
                    <!-- Icon from Material Symbols Light by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                    <path
                      fill="currentColor"
                      d="M17 21q-1.671 0-2.835-1.164Q13 18.67 13 17t1.165-2.835T17 13t2.836 1.165T21 17t-1.164 2.836T17 21M5 11.1V6.817q0-.51.295-.923t.755-.6l5.385-2q.292-.106.565-.106t.566.106l5.384 2q.46.187.755.6t.295.923v3.57q0 .348-.279.572t-.646.157q-.258-.068-.534-.092Q17.264 11 17 11q-2.496 0-4.248 1.752T11 17q0 .627.14 1.274q.139.647.45 1.326q.187.398-.108.716t-.693.15q-1.147-.512-2.08-1.293q-.932-.78-1.703-1.865q-.94-1.322-1.473-2.901T5 11.1M17 17q.625 0 1.063-.437T18.5 15.5t-.437-1.062T17 14t-1.062.438T15.5 15.5t.438 1.063T17 17m0 3q.644 0 1.233-.247q.588-.247 1.013-.736q.106-.13.071-.28q-.034-.148-.176-.23q-.495-.263-1.036-.385T17 18t-1.105.122t-1.035.386q-.143.08-.177.23q-.035.149.07.28q.426.488 1.014.735T17 20"
                    />
                  </svg>
                </li>
              </router-link>
              <li
                style="border-radius: 28px; cursor: pointer"
                @click="
                  persistentRef = true;
                  searchFocus();
                "
              >
                <div>
                  <svg
                    class="hover:scale-110 duration-300"
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="M9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612T9.5 3t4.613 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l5.6 5.6q.275.275.275.7t-.275.7t-.7.275t-.7-.275l-5.6-5.6q-.75.6-1.725.95T9.5 16m0-2q1.875 0 3.188-1.312T14 9.5t-1.312-3.187T9.5 5T6.313 6.313T5 9.5t1.313 3.188T9.5 14"
                    />
                  </svg>
                </div>
                <v-dialog v-model="persistentRef" max-width="1400px" content-class="top-0">
                  <v-card
                    class="bg-1"
                    style="background: none; border-radius: 1.5rem; box-shadow: none; overflow: visible"
                  >
                    <div
                      class="px-10 py-7 shadow-2xl mb-4 text-[#c7cef8]"
                      style="border-radius: 1.5rem; background: linear-gradient(45deg, #434d95, rgb(34, 50, 85))"
                    >
                      <div class="flex">
                        <v-text-field
                          :label="$t('header.menu.search')"
                          prepend-inner-icon="mdi-magnify"
                          id="searchAnimeHeader"
                          autocomplete="off"
                          clearable
                          variant="solo"
                          density="comfortable"
                          hide-details
                          single-line
                          rounded="2xl"
                          type="search"
                          bg-color="#c7cef8"
                          @input="search"
                          @focusin="searchFocusIn"
                          @click:clear="visibleAnime = []"
                          v-model="query"
                          class="text-white w-4/5 mr-2"
                        ></v-text-field>
                        <svg
                          @click="toggleSettingsSearch = !toggleSettingsSearch"
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="48"
                          viewBox="0 0 24 24"
                          class="text-[#c7cef8] cursor-pointer p-1 hover:scale-105 duration-200 select-none"
                        >
                          <!-- Icon from Mage Icons by MageIcons - https://github.com/Mage-Icons/mage-icons/blob/main/License.txt -->
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            stroke-width="1.5"
                            d="M21.25 12H8.895m-4.361 0H2.75m18.5 6.607h-5.748m-4.361 0H2.75m18.5-13.214h-3.105m-4.361 0H2.75m13.214 2.18a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm-9.25 6.607a2.18 2.18 0 1 0 0-4.36a2.18 2.18 0 0 0 0 4.36Zm6.607 6.608a2.18 2.18 0 1 0 0-4.361a2.18 2.18 0 0 0 0 4.36Z"
                          />
                        </svg>
                      </div>
                      <div class="h-0 hidden md:block">
                        <v-chip
                          v-if="(settingsSearch.sorted != 'Pertinence' || settingsSearch.desc) && settingsSearch.sorted"
                          size="x-small"
                          class="mr-1"
                          closable
                          @click="toggleSettingsSearch = true"
                          @click:close="
                            toggleSettingsSearch = true;
                            settingsSearch.sorted = 'Pertinence';
                          "
                        >
                          {{ settingsSearch.desc ? settingsSearch.sorted + " décroissant(e)" : settingsSearch.sorted }}
                        </v-chip>
                        <v-chip
                          v-if="settingsSearch.format"
                          size="x-small"
                          class="mr-1"
                          closable
                          @click="toggleSettingsSearch = true"
                          @click:close="
                            toggleSettingsSearch = true;
                            settingsSearch.format = null;
                          "
                        >
                          {{ settingsSearch.format }}
                        </v-chip>
                        <v-chip
                          v-if="settingsSearch.genre?.length"
                          size="x-small"
                          class="mr-1"
                          closable
                          @click="toggleSettingsSearch = true"
                          @click:close="
                            toggleSettingsSearch = true;
                            settingsSearch.genre = null;
                          "
                        >
                          {{ settingsSearch.genre?.join(" | ") }}
                        </v-chip>
                        <v-chip
                          v-if="settingsSearch.studio"
                          size="x-small"
                          class="mr-1"
                          closable
                          @click="toggleSettingsSearch = true"
                          @click:close="
                            toggleSettingsSearch = true;
                            settingsSearch.studio = null;
                          "
                        >
                          {{ settingsSearch.studio }}
                        </v-chip>
                        <v-chip
                          v-if="
                            settingsSearch.annee[0] != 1961 || settingsSearch.annee[1] != new Date().getFullYear() + 1
                          "
                          size="x-small"
                          class="mr-1"
                          closable
                          @click="toggleSettingsSearch = true"
                          @click:close="
                            toggleSettingsSearch = true;
                            settingsSearch.annee = [1961, new Date().getFullYear() + 1];
                          "
                        >
                          {{ settingsSearch.annee[0] + "-" + settingsSearch.annee[1] }}
                        </v-chip>
                        <v-chip
                          v-if="settingsSearch.saison"
                          size="x-small"
                          class="mr-1"
                          closable
                          @click="toggleSettingsSearch = true"
                          @click:close="
                            toggleSettingsSearch = true;
                            settingsSearch.saison = null;
                          "
                        >
                          {{
                            settingsSearch.saison == 1
                              ? "Winter"
                              : settingsSearch.saison == 2
                              ? "Spring"
                              : settingsSearch.saison == 3
                              ? "Summer"
                              : settingsSearch.saison == 4
                              ? "Fall"
                              : null
                          }}
                        </v-chip>
                        <v-chip
                          v-if="settingsSearch.origine"
                          size="x-small"
                          class="mr-1"
                          closable
                          @click="toggleSettingsSearch = true"
                          @click:close="
                            toggleSettingsSearch = true;
                            settingsSearch.origine = null;
                          "
                        >
                          {{ settingsSearch.origine }}
                        </v-chip>
                      </div>
                    </div>
                    <div
                      v-if="toggleSettingsSearch"
                      style="
                        color: white;
                        border-radius: 1.5rem;
                        background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #223255 100%);
                      "
                    >
                      <v-card class="p-10" style="background: none; box-shadow: none; color: white">
                        <div class="font-medium text-2xl mb-4">Affiner la recherche</div>
                        <div
                          style="max-height: calc(-400px + 100vh)"
                          class="lg:overflow-hidden overflow-y-auto overflow-x-hidden"
                        >
                          <v-row>
                            <!-- Nombre d'épisodes -->
                            <v-col cols="12" md="6" class="flex">
                              <v-autocomplete
                                v-model.number="settingsSearch.sorted"
                                label="Trier par"
                                :items="sorted"
                                clearable
                              ></v-autocomplete>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="56"
                                height="56"
                                class="p-2 ml-1 cursor-pointer rounded-xl"
                                style="background: rgb(255 255 255 / 5%); transform: rotate(180deg)"
                                :style="{
                                  transform: settingsSearch.desc ? 'scaleX(-1)' : 'rotate(180deg)',
                                }"
                                @click="settingsSearch.desc = !settingsSearch.desc"
                                viewBox="0 0 24 24"
                              >
                                <!-- Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE -->
                                <path
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 6h16M7 12h13m-10 6h10"
                                />
                              </svg>
                            </v-col>
                            <!-- Format -->
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="settingsSearch.format"
                                :items="formats"
                                label="Format"
                                clearable
                              ></v-autocomplete>
                            </v-col>
                            <!-- Genre -->
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="settingsSearch.genre"
                                :items="genres"
                                label="Genre"
                                multiple
                                chips
                                clearable
                                closable-chips
                              ></v-autocomplete>
                            </v-col>

                            <!-- Studio -->
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="settingsSearch.studio"
                                :items="studios"
                                label="Studio"
                                clearable
                              ></v-autocomplete>
                            </v-col>

                            <!-- Année -->
                            <v-col cols="12" md="6" class="flex font-semibold">
                              <span class="ml-3 text-lg whitespace-nowrap">Année :</span>
                              <div class="relative flex px-16 ml-5 w-3/4">
                                <span class="text-xl absolute left-[0px] pt-[2px]">{{ settingsSearch.annee[0] }}</span>
                                <v-range-slider
                                  v-model="settingsSearch.annee"
                                  color="#c7cef8"
                                  step="1"
                                  class="h-[50px]"
                                  min="1961"
                                  :max="new Date().getFullYear() + 1"
                                ></v-range-slider>
                                <span class="text-xl absolute right-[0px] pt-[2px]">{{ settingsSearch.annee[1] }}</span>
                              </div>
                            </v-col>
                            <!-- Saison -->
                            <v-col cols="12" md="6" class="relative flex font-semibold">
                              <span class="mr-5 ml-3 text-lg whitespace-nowrap">Saison :</span>
                              <v-slider
                                :max="4"
                                tick-size="4"
                                track-size="6"
                                :ticks="tickLabels"
                                show-ticks="always"
                                class="h-[50px] max-w-[75%]"
                                color="#c7cef8"
                                track-fill-color="#00000000"
                                v-model="settingsSearch.saison"
                                step="1"
                              ></v-slider>
                            </v-col>

                            <!-- Origine -->
                            <v-col cols="12" md="6">
                              <v-autocomplete
                                v-model="settingsSearch.origine"
                                :items="origines"
                                label="Origine"
                                clearable
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                        </div>

                        <div class="flex justify-between mt-4">
                          <div>
                            <v-btn class="bg-linear mr-1 text-white" @click="settingsSearchFunc" v-if="!loading"
                              >Rechercher</v-btn
                            >
                            <v-progress-circular :size="36" color="#c7cef8" indeterminate v-else></v-progress-circular>
                            <v-btn class="bg-second" @click="resetFilters">Réinitialiser</v-btn>
                          </div>

                          <v-btn
                            class="bg-second"
                            @click="
                              resetFilters();
                              annuler();
                            "
                            >Annuler</v-btn
                          >
                        </div>
                      </v-card>
                    </div>
                    <div
                      v-else-if="!visibleAnime?.length && !query && !servSearch"
                      class="p-10 shadow-2xl"
                      style="
                        max-height: calc(100vh - 150px);
                        overflow: auto;
                        border-radius: 1.5rem;
                        background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #223255 100%);
                        color: white;
                      "
                    >
                      <div class="discover mb-4">
                        <div class="font-medium text-2xl mb-4">{{ $t("anime.now") }}</div>
                        <swiper
                          :modules="modules"
                          :spaceBetween="15"
                          :slidesPerView="1"
                          :navigation="true"
                          :freeMode="true"
                          :virtual="true"
                          :breakpoints="{
                            660: {slidesPerGroup: 2, slidesPerView: 3},
                            860: {slidesPerGroup: 3, slidesPerView: 4},
                            1060: {slidesPerGroup: 4, slidesPerView: 5},
                            1260: {slidesPerGroup: 5, slidesPerView: 6},
                          }"
                        >
                          <swiper-slide
                            v-for="(card, index2) in global.animesSuggest[2]"
                            :key="index2"
                            :virtualIndex="index2"
                            class="min-w-[13svh] max-w-[13svh] imgPoster select-none"
                          >
                            <v-img
                              @click="open(card?.url)"
                              :alt="card?.title"
                              loading="lazy"
                              class="rounded-[1.25rem] cursor-pointer"
                              :src="'https://api.baranimes.com/images/upload/' + card?.poster"
                            >
                              <template v-slot:placeholder>
                                <v-sheet>
                                  <v-skeleton-loader
                                    type="image"
                                    class="rounded-[1.25rem] overflow-hidden"
                                    color="#00000000"
                                  ></v-skeleton-loader>
                                </v-sheet>
                              </template>
                            </v-img>
                            <div
                              class="font-medium line-clamp-2 leading-5 my-1 cursor-pointer"
                              @click="open(card?.url)"
                            >
                              {{ card?.title }}
                            </div>
                            <div class="text-gray-200 text-xs">{{ formaterDate(card?.debut) }}</div>
                          </swiper-slide>
                        </swiper>
                      </div>
                      <div class="discover">
                        <div class="font-medium text-2xl mb-4 pt-2">{{ $t("anime.coming") }}</div>
                        <swiper
                          :modules="modules"
                          :spaceBetween="15"
                          :slidesPerView="1"
                          :navigation="true"
                          :freeMode="true"
                          :virtual="true"
                          :breakpoints="{
                            660: {slidesPerGroup: 2, slidesPerView: 3},
                            860: {slidesPerGroup: 3, slidesPerView: 4},
                            1060: {slidesPerGroup: 4, slidesPerView: 5},
                            1260: {slidesPerGroup: 5, slidesPerView: 6},
                          }"
                        >
                          <swiper-slide
                            v-for="(card, index2) in global.animesSuggest[3]"
                            :key="index2"
                            :virtualIndex="index2"
                            class="min-w-[13svh] max-w-[13svh] imgPoster select-none"
                          >
                            <v-img
                              @click="open(card?.url)"
                              :alt="card?.title"
                              loading="lazy"
                              class="rounded-[1.25rem] cursor-pointer"
                              :src="'https://api.baranimes.com/images/upload/' + card?.poster"
                            >
                              <template v-slot:placeholder>
                                <v-sheet>
                                  <v-skeleton-loader
                                    type="image"
                                    class="rounded-[1.25rem] overflow-hidden"
                                    color="#00000000"
                                  ></v-skeleton-loader>
                                </v-sheet>
                              </template>
                            </v-img>
                            <div
                              class="font-medium line-clamp-2 leading-5 my-1 cursor-pointer"
                              @click="open(card?.url)"
                            >
                              {{ card?.title }}
                            </div>
                            <div class="text-gray-200 text-xs">{{ formaterDate(card?.debut) }}</div>
                          </swiper-slide>
                        </swiper>
                      </div>
                    </div>
                    <div
                      v-else
                      style="
                        background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #223255 100%);
                        border-radius: 1.5rem;
                        color: white;
                      "
                    >
                      <div class="flex mt-6 mb-4 justify-center">
                        <div class="flex ml-4 absolute left-0" id="choose">
                          <span
                            :class="{active: choose === 0}"
                            @click="
                              choose = 0;
                              search();
                            "
                            >Anime</span
                          >
                          <span
                            :class="{active: choose === 1}"
                            @click="
                              choose = 1;
                              search();
                            "
                            >Membre</span
                          >
                        </div>
                        <p class="text-center text-2xl uppercase font-medium" v-if="!loadSearch">
                          {{ visibleAnimeTempo?.length }} resultat{{ visibleAnimeTempo?.length > 1 ? "s" : "" }}
                        </p>
                        <v-progress-circular
                          size="32"
                          class="text-center text-2xl uppercase font-medium"
                          color="#c7cef8"
                          indeterminate
                          style="width: 100%"
                          v-else
                        ></v-progress-circular>
                      </div>

                      <v-virtual-scroll
                        :class="{hidden: visibleAnime?.length === 0}"
                        :items="visibleAnime"
                        item-height="350"
                        id="animeListHeader"
                        height="2000"
                        style="max-height: calc(90svh - 150px)"
                        class="p-6 pt-0 h-full"
                      >
                        <template v-slot:default="{item}">
                          <div class="flex justify-center" v-if="choose == 0">
                            <v-sheet
                              v-for="items in item"
                              :key="items.url"
                              class="min-w-[168px] max-w-[168px] imgPoster select-none bg-transparent m-2 mb-6"
                              @click="open(items.url)"
                            >
                              <v-img
                                :alt="items?.title"
                                loading="lazy"
                                class="rounded-[1.25rem] cursor-pointer"
                                draggable="false"
                                :src="'https://api.baranimes.com/images/upload/' + items?.image"
                                width="168"
                                height="250"
                                :class="{'blur-md': items?.nsfw == 18}"
                              >
                              </v-img>
                              <div class="font-medium line-clamp-2 leading-5 my-1 text-white cursor-pointer">
                                {{ items?.title }}
                              </div>
                              <div class="text-gray-200 text-xs">{{ formaterDate(items?.aired) }}</div>
                            </v-sheet>
                          </div>
                          <div class="flex justify-center" v-if="choose == 1">
                            <v-sheet
                              v-for="items in item"
                              :key="items.url"
                              class="min-w-[168px] max-w-[168px] imgPoster select-none bg-transparent m-2 mb-6"
                              @click="open(items.url, 2)"
                            >
                              <div
                                class="relative flex items-center flex-col rounded-[1.25rem]"
                                :style="`background: url(https://api.baranimes.com/images/global/bg_avatar.png) 0% 0% / cover,
                            ${items.fond}`"
                              >
                                <img
                                  :src="'https://api.baranimes.com/images/decor/' + items?.decor"
                                  class="absolute h-[250px]"
                                  style="max-width: fit-content"
                                  :style="`z-index:${items.zindex + 1}%`"
                                />
                                <img
                                  loading="lazy"
                                  class="cursor-pointer z-[1] h-[250px] object-contain"
                                  draggable="false"
                                  :src="'https://api.baranimes.com/images/avatar_users/' + items?.lien"
                                  width="168"
                                  height="250"
                                  :style="`padding:${15 - items.padding}%`"
                                />
                              </div>

                              <div
                                class="font-medium line-clamp-2 leading-5 my-1 text-white cursor-pointer self-start ml-2"
                              >
                                {{ items?.username }}
                              </div>
                              <div class="text-gray-200 text-xs opacity-0">NAN</div>
                            </v-sheet>
                          </div>
                        </template>
                      </v-virtual-scroll>
                    </div>
                  </v-card>
                </v-dialog>
              </li>
              <li style="border-radius: 28px; cursor: pointer" v-if="auth.user.role == 'guest'">
                <v-menu class="rounded-md shadow-2xl">
                  <template v-slot:activator="{props}">
                    <svg
                      class="hover:scale-110 duration-300 m-1 mr-[10px]"
                      v-bind="props"
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 16 16"
                    >
                      <!-- Icon from Bootstrap Icons by The Bootstrap Authors - https://github.com/twbs/icons/blob/main/LICENSE.md -->
                      <g fill="currentColor">
                        <path
                          d="M4.545 6.714L4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z"
                        />
                        <path
                          d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292c.178.217.451.635.555.867c1.125-.359 2.08-.844 2.886-1.494c.777.665 1.739 1.165 2.93 1.472c.133-.254.414-.673.629-.89c-1.125-.253-2.057-.694-2.82-1.284c.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492a2 2 0 0 1-.94.31"
                        />
                      </g>
                    </svg>
                  </template>
                  <div class="rounded-2xl overflow-hidden text-[#fff] bg-[#3c5082] mt-2 flex flex-col shadow-2xl">
                    <a
                      :href="'/' + item.iso + $route.fullPath"
                      v-for="(item, index) in langs"
                      :key="index"
                      :value="index"
                      class="hover:bg-[#4b6198] px-4 py-2 langs"
                      :class="{active: selectedLanguage == item.iso}"
                    >
                      {{ item.title }}
                    </a>
                  </div>
                </v-menu>
              </li>
              <!-- <li>
                <svg
                  v-if="!fullScreen"
                  @click="openFullscreen"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="27"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="currentColor"
                    d="M13 3.5v3a.5.5 0 0 1-1 0V4.71L9.85 6.86a.5.5 0 0 1-.707-.707l2.15-2.15h-1.79a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .351.144l.004.004a.5.5 0 0 1 .144.348v.004zM3.5 9a.5.5 0 0 1 .5.5v1.79l2.15-2.15a.5.5 0 0 1 .707.707l-2.15 2.15h1.79a.5.5 0 0 1 0 1H3.494a.5.5 0 0 1-.497-.499v-3a.5.5 0 0 1 .5-.5z"
                  />
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M0 4.8c0-1.68 0-2.52.327-3.16A3.02 3.02 0 0 1 1.637.33c.642-.327 1.48-.327 3.16-.327h6.4c1.68 0 2.52 0 3.16.327a3.02 3.02 0 0 1 1.31 1.31c.327.642.327 1.48.327 3.16v6.4c0 1.68 0 2.52-.327 3.16a3 3 0 0 1-1.31 1.31c-.642.327-1.48.327-3.16.327h-6.4c-1.68 0-2.52 0-3.16-.327a3 3 0 0 1-1.31-1.31C0 13.718 0 12.88 0 11.2zM4.8 1h6.4c.857 0 1.44 0 1.89.038c.438.035.663.1.819.18c.376.192.682.498.874.874c.08.156.145.38.18.819c.037.45.038 1.03.038 1.89v6.4c0 .857-.001 1.44-.038 1.89c-.036.438-.101.663-.18.819a2 2 0 0 1-.874.874c-.156.08-.381.145-.819.18c-.45.036-1.03.037-1.89.037H4.8c-.857 0-1.44 0-1.89-.037c-.438-.036-.663-.101-.819-.18a2 2 0 0 1-.874-.874c-.08-.156-.145-.381-.18-.82C1 12.64.999 12.06.999 11.2V4.8c0-.856.001-1.44.038-1.89c.036-.437.101-.662.18-.818c.192-.376.498-.682.874-.874c.156-.08.381-.145.819-.18C3.36 1 3.94 1 4.8 1"
                    clip-rule="evenodd"
                  />
                </svg>
                <svg
                  v-else
                  @click="closeFullscreen"
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="27"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="currentColor"
                    d="M8 1.5a.5.5 0 0 0-.5-.5H4.2c-1.12 0-1.68 0-2.11.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.11v3.3a.5.5 0 0 0 1 0v-3.3c0-.577 0-.949.024-1.23c.022-.272.06-.372.085-.422c.096-.188.249-.341.437-.437c.05-.025.15-.063.422-.085c.283-.023.656-.024 1.23-.024h3.3a.5.5 0 0 0 .5-.5zm7 10.3V8.5a.5.5 0 0 0-1 0v3.3c0 .577 0 .949-.024 1.23c-.022.272-.06.372-.085.422a1 1 0 0 1-.437.437c-.05.025-.15.063-.422.085c-.283.023-.656.024-1.23.024h-3.3a.5.5 0 0 0 0 1h3.3c1.12 0 1.68 0 2.11-.218c.376-.192.682-.498.874-.874c.218-.428.218-.988.218-2.11zM6.85 9.15a.5.5 0 0 1 .147.35v3.003a.5.5 0 0 1-1 0v-1.79l-4.15 4.15a.5.5 0 0 1-.707-.707l4.15-4.15H3.5a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .191.038q.09.036.162.11zM10.7 6l4.15-4.15a.5.5 0 0 0-.707-.707l-4.15 4.15v-1.79a.5.5 0 0 0-1 0v3.003a.5.5 0 0 0 .309.46a.5.5 0 0 0 .19.037h3a.5.5 0 0 0 0-1h-1.79z"
                  />
                </svg>
              </li> -->
              <li class="lg:flex coins ml-2 hidden" v-if="auth.user.role != 'guest'">
                <div class="flex items-center mr-[30px]">
                  <img
                    draggable="false"
                    loading="lazy"
                    src="https://api.baranimes.com/images/global/gv2.png"
                    class="h-[22px]"
                  />
                  <span class="text-[14px] mr-3">{{ auth.user?.baraticket.toLocaleString() }}</span>
                  <router-link to="/buy/binyl">
                    <button class="more bg-linear" style="position: absolute; right: -23px; top: -12px">
                      <span class="line1"></span><span class="line2"></span>
                    </button>
                  </router-link>
                </div>
                <div class="flex items-center">
                  <img
                    draggable="false"
                    loading="lazy"
                    src="https://api.baranimes.com/images/global/v.png"
                    class="h-[22px]"
                  />
                  <span class="text-[14px]">{{ auth.user?.baracoins.toLocaleString() }}</span>
                </div>
              </li>

              <v-menu
                open-on-hover
                open-on-click="false"
                open-delay="0"
                close-delay="0"
                transition="fade"
                location
                content-class="pointer-events-none"
                v-if="auth.user.role != 'guest'"
              >
                <template v-slot:activator="{props}">
                  <li class="flex items-center cursor-pointer" @click="open('profile', 2)" v-bind="props">
                    <v-avatar
                      size="41"
                      :image="`https://api.baranimes.com/images/minia/${auth.user?.minia}`"
                      :style="`background: url(https://api.baranimes.com/images/global/bg_avatar.png) 0% 0% / cover, ${auth.user.fond}`"
                    ></v-avatar>
                    <div class="ml-[9px] hidden lg:block">
                      <p>{{ auth.user.username }}</p>
                      <div class="flex items-center">
                        <p>lvl {{ auth.user.lvl }}</p>
                        <span
                          style="height: 8px; width: 50px; margin-left: 4px; border-radius: 100px"
                          :style="`background: linear-gradient(90deg, rgb(245 79 103) ${auth.user.pts}%, rgb(95 109 150) 0%)`"
                        ></span>
                      </div>
                    </div>
                    <svg
                      class="hidden lg:block"
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M11.475 14.475L7.85 10.85q-.075-.075-.112-.162T7.7 10.5q0-.2.138-.35T8.2 10h7.6q.225 0 .363.15t.137.35q0 .05-.15.35l-3.625 3.625q-.125.125-.25.175T12 14.7t-.275-.05t-.25-.175"
                      />
                    </svg>
                  </li>
                </template>

                <v-list
                  class="mt-[68px] pt-3 p-0 pointer-events-auto w-[195px]"
                  style="background: transparent; box-shadow: none; overflow: visible"
                >
                  <div
                    class="rounded-2xl overflow-hidden text-[#fff] bg-[#3c5082]"
                    style="box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25)"
                  >
                    <v-list-item class="hover:bg-[#4b6198] cursor-pointer">
                      <template v-slot:prepend>
                        <svg
                          class="mr-4 opacity-80"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M5.85 17.1q1.275-.975 2.85-1.537T12 15t3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4T6.337 6.338T4 12q0 1.475.488 2.775T5.85 17.1M12 13q-1.475 0-2.488-1.012T8.5 9.5t1.013-2.488T12 6t2.488 1.013T15.5 9.5t-1.012 2.488T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
                          />
                        </svg>
                      </template>
                      <v-list-item-title class="font-semibold" @click="open('profile', 2)">Profil</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="hover:bg-[#4b6198] cursor-pointer">
                      <template v-slot:prepend>
                        <svg
                          class="mr-4 opacity-80"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M8.5 11.5h7v-1h-7zm0-4h7v-1h-7zm10.412 12.437l-3.416-4.43q-.367-.478-.877-.742q-.51-.265-1.119-.265H5V4.616q0-.691.463-1.153T6.616 3h10.769q.69 0 1.153.463T19 4.616v14.769q0 .144-.022.285q-.022.142-.066.267M6.616 21q-.691 0-1.153-.462T5 19.385V15.5h8.5q.366 0 .674.16q.309.161.536.457l3.527 4.616q-.183.127-.397.197t-.456.07z"
                          />
                        </svg>
                      </template>
                      <v-list-item-title class="font-semibold" @click="open('profile', 2)"
                        >Mes listes</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item class="hover:bg-[#4b6198] cursor-pointer">
                      <template v-slot:prepend>
                        <svg
                          class="mr-4 opacity-80"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="m9.25 22l-.4-3.2q-.325-.125-.612-.3t-.563-.375L4.7 19.375l-2.75-4.75l2.575-1.95Q4.5 12.5 4.5 12.338v-.675q0-.163.025-.338L1.95 9.375l2.75-4.75l2.975 1.25q.275-.2.575-.375t.6-.3l.4-3.2h5.5l.4 3.2q.325.125.613.3t.562.375l2.975-1.25l2.75 4.75l-2.575 1.95q.025.175.025.338v.674q0 .163-.05.338l2.575 1.95l-2.75 4.75l-2.95-1.25q-.275.2-.575.375t-.6.3l-.4 3.2zm2.8-6.5q1.45 0 2.475-1.025T15.55 12t-1.025-2.475T12.05 8.5q-1.475 0-2.488 1.025T8.55 12t1.013 2.475T12.05 15.5"
                          />
                        </svg>
                      </template>
                      <v-list-item-title class="font-semibold" @click="open('settings', 2)"
                        >Paramètres</v-list-item-title
                      >
                    </v-list-item>
                    <router-link v-if="auth.user.role == 'admin'" to="/admin">
                      <v-list-item class="hover:bg-[#4b6198]">
                        <template v-slot:prepend>
                          <svg
                            class="mr-4 opacity-80"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <!-- Icon from Material Symbols Light by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                            <path
                              fill="currentColor"
                              d="M17 21q-1.671 0-2.835-1.164Q13 18.67 13 17t1.165-2.835T17 13t2.836 1.165T21 17t-1.164 2.836T17 21M5 11.1V6.817q0-.51.295-.923t.755-.6l5.385-2q.292-.106.565-.106t.566.106l5.384 2q.46.187.755.6t.295.923v3.57q0 .348-.279.572t-.646.157q-.258-.068-.534-.092Q17.264 11 17 11q-2.496 0-4.248 1.752T11 17q0 .627.14 1.274q.139.647.45 1.326q.187.398-.108.716t-.693.15q-1.147-.512-2.08-1.293q-.932-.78-1.703-1.865q-.94-1.322-1.473-2.901T5 11.1M17 17q.625 0 1.063-.437T18.5 15.5t-.437-1.062T17 14t-1.062.438T15.5 15.5t.438 1.063T17 17m0 3q.644 0 1.233-.247q.588-.247 1.013-.736q.106-.13.071-.28q-.034-.148-.176-.23q-.495-.263-1.036-.385T17 18t-1.105.122t-1.035.386q-.143.08-.177.23q-.035.149.07.28q.426.488 1.014.735T17 20"
                            />
                          </svg>
                        </template>
                        <v-list-item-title class="font-semibold">Espace admin</v-list-item-title>
                      </v-list-item>
                    </router-link>
                    <v-list-item class="hover:bg-[#4b6198]" v-if="auth.user.role == 'admin'" @click="toggleOutils">
                      <template v-slot:prepend>
                        <svg
                          class="mr-4 opacity-80"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="m9.25 22l-.4-3.2q-.325-.125-.612-.3t-.563-.375L4.7 19.375l-2.75-4.75l2.575-1.95Q4.5 12.5 4.5 12.338v-.675q0-.163.025-.338L1.95 9.375l2.75-4.75l2.975 1.25q.275-.2.575-.375t.6-.3l.4-3.2h5.5l.4 3.2q.325.125.613.3t.562.375l2.975-1.25l2.75 4.75l-2.575 1.95q.025.175.025.338v.674q0 .163-.05.338l2.575 1.95l-2.75 4.75l-2.95-1.25q-.275.2-.575.375t-.6.3l-.4 3.2zm2.8-6.5q1.45 0 2.475-1.025T15.55 12t-1.025-2.475T12.05 8.5q-1.475 0-2.488 1.025T8.55 12t1.013 2.475T12.05 15.5"
                          />
                        </svg>
                      </template>
                      <v-list-item-title class="font-semibold">Outils admin</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="hover:bg-[#4b6198] cursor-pointer" @click="logout()">
                      <template v-slot:prepend>
                        <svg
                          class="mr-4 opacity-80 text-[#f54f67]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M4 5.4A1.4 1.4 0 0 1 5.4 4h6.2A1.4 1.4 0 0 1 13 5.4V8a1 1 0 1 0 2 0V5.4A3.4 3.4 0 0 0 11.6 2H5.4A3.4 3.4 0 0 0 2 5.4v13.2A3.4 3.4 0 0 0 5.4 22h6.2a3.4 3.4 0 0 0 3.4-3.4V16a1 1 0 1 0-2 0v2.6a1.4 1.4 0 0 1-1.4 1.4H5.4A1.4 1.4 0 0 1 4 18.6z"
                          />
                          <path
                            fill="currentColor"
                            d="M17.293 8.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L18.586 13H7a1 1 0 1 1 0-2h11.586l-1.293-1.293a1 1 0 0 1 0-1.414"
                          />
                        </svg>
                      </template>
                      <v-list-item-title class="font-bold text-[#f54f67]">Se déconnecter</v-list-item-title>
                    </v-list-item>
                  </div>
                </v-list>
              </v-menu>
              <li
                class="bg-linear hover:scale-105 duration-300"
                style="border-radius: 28px; color: white; cursor: pointer; padding: 10px 18px; font-size: 15px"
                v-else
                @click="global.dialogRegister = true"
              >
                <span>Rejoindre</span>
              </li>
              <v-dialog v-model="global.dialogRegister" max-width="500" :persistent="persistentRegister">
                <RegisterView @change-persistent="updatePersistent" />
              </v-dialog>
              <router-link
                to="/testhome"
                v-if="
                  $route.path != '/testhome' &&
                  $route.path != '/testroom' &&
                  $route.path != '/ascension' &&
                  auth.user.role == 'guest'
                "
              >
                <li class="cursor-scale play2 play hidden sm:block">Jouer</li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </header>
    <div
      v-if="auth.user.role != 'guest'"
      class="sidebar-right hidden xl:flex"
      id="sidebar-right"
      :class="{expanded: menu || global.sidebar}"
    >
      <div class="min-w-[56px] pointer-events-none child duration-200 flex-col flex justify-between items-center">
        <div
          style="border-bottom: 1px solid rgb(255 255 255 / 32%)"
          class="h-[48px] flex justify-center items-center w-full"
        >
          <v-badge :content="1" color="#f54f67">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" class="self-center">
              <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
              <path
                fill="currentColor"
                d="M1 18q-.425 0-.712-.288T0 17v-.575q0-1.075 1.1-1.75T4 14q.325 0 .625.013t.575.062q-.35.525-.525 1.1t-.175 1.2V18zm6 0q-.425 0-.712-.288T6 17v-.625q0-.8.438-1.463t1.237-1.162T9.588 13T12 12.75q1.325 0 2.438.25t1.912.75t1.225 1.163t.425 1.462V17q0 .425-.287.713T17 18zm12.5 0v-1.625q0-.65-.162-1.225t-.488-1.075q.275-.05.563-.062T20 14q1.8 0 2.9.663t1.1 1.762V17q0 .425-.288.713T23 18zM4 13q-.825 0-1.412-.587T2 11q0-.85.588-1.425T4 9q.85 0 1.425.575T6 11q0 .825-.575 1.413T4 13m16 0q-.825 0-1.412-.587T18 11q0-.85.588-1.425T20 9q.85 0 1.425.575T22 11q0 .825-.575 1.413T20 13m-8-1q-1.25 0-2.125-.875T9 9q0-1.275.875-2.137T12 6q1.275 0 2.138.863T15 9q0 1.25-.862 2.125T12 12"
              />
            </svg>
          </v-badge>
        </div>
        <v-badge dot location="bottom end" :color="statusColors[myStatusRef]" class="mb-5 h-9 w-9">
          <v-img
            class="rounded-full"
            :src="'https://api.baranimes.com/images/minia/minori.png'"
            style="
              background: url('https://api.baranimes.com/images/global/bg_avatar.png') 0% 0% / cover,
                linear-gradient(rgb(197, 197, 197), rgb(0, 140, 168));
            "
          ></v-img>
        </v-badge>
      </div>
      <div class="flex flex-col justify-between">
        <v-tabs v-model="tab" class="text-white w-full" style="border-bottom: 1px solid rgb(255 255 255 / 32%)">
          <v-tab :value="1" class="w-[100px]">
            <v-badge :content="1" color="#f54f67">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                <path
                  fill="currentColor"
                  d="M1 18q-.425 0-.712-.288T0 17v-.575q0-1.075 1.1-1.75T4 14q.325 0 .625.013t.575.062q-.35.525-.525 1.1t-.175 1.2V18zm6 0q-.425 0-.712-.288T6 17v-.625q0-.8.438-1.463t1.237-1.162T9.588 13T12 12.75q1.325 0 2.438.25t1.912.75t1.225 1.163t.425 1.462V17q0 .425-.287.713T17 18zm12.5 0v-1.625q0-.65-.162-1.225t-.488-1.075q.275-.05.563-.062T20 14q1.8 0 2.9.663t1.1 1.762V17q0 .425-.288.713T23 18zM4 13q-.825 0-1.412-.587T2 11q0-.85.588-1.425T4 9q.85 0 1.425.575T6 11q0 .825-.575 1.413T4 13m16 0q-.825 0-1.412-.587T18 11q0-.85.588-1.425T20 9q.85 0 1.425.575T22 11q0 .825-.575 1.413T20 13m-8-1q-1.25 0-2.125-.875T9 9q0-1.275.875-2.137T12 6q1.275 0 2.138.863T15 9q0 1.25-.862 2.125T12 12"
                />
              </svg>
            </v-badge>
          </v-tab>
          <v-tab :value="2" class="w-[100px]">
            <v-badge :content="1" color="#f54f67">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                <!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE -->
                <path
                  fill="currentColor"
                  d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2m6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.89 0 1.34-1.08.71-1.71z"
                />
              </svg>
            </v-badge>
          </v-tab>
          <v-tab :value="3" class="w-[100px]">
            <v-badge :content="1" color="#f54f67">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <!-- Icon from Mage Icons by MageIcons - https://github.com/Mage-Icons/mage-icons/blob/main/License.txt -->
                <path
                  fill="currentColor"
                  d="M20.372 3.86v10.88a.75.75 0 0 1-.43.68a11.85 11.85 0 0 1-4.64 1.16a5.9 5.9 0 0 1-3.71-1.21a4.45 4.45 0 0 0-2.85-1a7.16 7.16 0 0 0-3.61.73v6.13a.75.75 0 1 1-1.5 0V3.86a1 1 0 0 1 0-.15a.76.76 0 0 1 .31-.47c.38-.32 1.73-1.22 4.78-1.22a5.87 5.87 0 0 1 3.68 1.22a4.46 4.46 0 0 0 2.85 1a10.3 10.3 0 0 0 4-1a.74.74 0 0 1 .72.05a.73.73 0 0 1 .4.57"
                />
              </svg>
            </v-badge>
          </v-tab>
          <v-tab :value="4" class="w-[100px]">
            <v-badge :content="1" color="#f54f67">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                <!-- Icon from MingCute Icon by MingCute Design - https://github.com/Richard9394/MingCute/blob/main/LICENSE -->
                <g fill="none" fill-rule="evenodd">
                  <path
                    d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"
                  />
                  <path
                    fill="currentColor"
                    d="M10.762 6.025a40 40 0 0 1-1.084 3.24c.362.334.7.699 1.048 1.047l.38-.76a1 1 0 0 1 1.601-.26l1.019 1.02l.38-.76a1 1 0 0 1 .216-.287a40 40 0 0 1-1.084-3.24C13.226 5.98 13.157 6 13.123 6l-.88.22a1 1 0 0 1-.486 0l-.88-.22c-.036 0-.102-.023-.115.025M3.788 17.29c-.148.281-.276.52-.38.709H3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2h-.409q-.155-.286-.38-.709a95 95 0 0 1-1.586-3.139c-1.235-2.559-2.654-5.808-3.462-8.67A2.025 2.025 0 0 0 13.22 4c-.423 0-.81.117-1.219.22c-.41-.103-.796-.22-1.22-.22c-.921 0-1.701.624-1.943 1.481c-.808 2.863-2.228 6.112-3.462 8.671a95 95 0 0 1-1.587 3.14"
                  />
                </g>
              </svg>
            </v-badge>
          </v-tab>
        </v-tabs>
        <v-window v-model="tab" class="flex-1 overflow-auto" id="win">
          <v-window-item :value="1" :key="1">
            <FriendsView :userStatuses="userStatuses" @open-profil="open" :myStatusRef="myStatusRef" />
          </v-window-item>
          <v-window-item :value="2" :key="2">Notifications</v-window-item>
          <v-window-item :value="3" :key="3">Missions</v-window-item>
          <v-window-item :value="4" :key="4">
            <div class="container">
              <img
                draggable="false"
                class="w-[150px] flex justify-self-center"
                src="https://api.baranimes.com/images/avatar_users/64f5bb5d1a2fd9.30522874.png"
              />
              <div class="stat-container">
                <div v-for="(stat, index) in stats" :key="stat.name" class="stat">
                  <span class="stat-name">{{ stat.name }}</span>
                  <button
                    class="btn-decrement"
                    @mousedown="startHold(index, 'decrement')"
                    @touchstart.prevent="startHold(index, 'decrement')"
                    @mouseup="stopHold"
                    @touchend="stopHold"
                    @mouseleave="stopHold"
                    :disabled="stat.value <= 0"
                  >
                    -
                  </button>

                  <span class="stat-value" @click="startEdit(index)" v-if="editingIndex !== index">
                    {{ stat.value }}
                  </span>

                  <input
                    v-else
                    type="number"
                    v-model.number="tempValue"
                    @blur="confirmEdit(index)"
                    @focus="$event.target.select()"
                    class="value-input"
                    id="value-input"
                    :min="0"
                    :max="remainingPoints + stat.value"
                  />

                  <button
                    class="btn-increment"
                    @mousedown="startHold(index, 'increment')"
                    @touchstart.prevent="startHold(index, 'increment')"
                    @mouseup="stopHold"
                    @touchend="stopHold"
                    @mouseleave="stopHold"
                    :disabled="remainingPoints <= 0"
                  >
                    +
                  </button>
                </div>
              </div>
              <div class="points-restants mb-2">Points restants: {{ remainingPoints }}</div>
              <div class="grid justify-center" id="playerInventory"></div>
            </div>
            <div class="container">
              <div class="inventory">
                <h3>Inventaire</h3>
                <div class="grid" id="chestInventory"></div>
              </div>
            </div>
          </v-window-item>
        </v-window>
        <div class="p-4">
          <div class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-2xl shadow">
            <v-menu v-model="menu" :close-on-content-click="false">
              <template v-slot:activator="{props}">
                <div class="flex items-center ml-1 p-1 flex-1 cursor-pointer" v-bind="props">
                  <v-badge dot location="bottom end" :color="statusColors[myStatusRef]">
                    <v-img
                      class="h-12 w-12 rounded-full"
                      :src="'https://api.baranimes.com/images/minia/minori.png'"
                      style="
                        background: url('https://api.baranimes.com/images/global/bg_avatar.png') 0% 0% / cover,
                          linear-gradient(rgb(197, 197, 197), rgb(0, 140, 168));
                      "
                    ></v-img>
                  </v-badge>
                  <span class="text-[1rem] ml-3">Seb</span>
                </div>
                <svg
                  @click="open('settings', 2)"
                  class="mr-4 opacity-80 cursor-pointer"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="m9.25 22l-.4-3.2q-.325-.125-.612-.3t-.563-.375L4.7 19.375l-2.75-4.75l2.575-1.95Q4.5 12.5 4.5 12.338v-.675q0-.163.025-.338L1.95 9.375l2.75-4.75l2.975 1.25q.275-.2.575-.375t.6-.3l.4-3.2h5.5l.4 3.2q.325.125.613.3t.562.375l2.975-1.25l2.75 4.75l-2.575 1.95q.025.175.025.338v.674q0 .163-.05.338l2.575 1.95l-2.75 4.75l-2.95-1.25q-.275.2-.575.375t-.6.3l-.4 3.2zm2.8-6.5q1.45 0 2.475-1.025T15.55 12t-1.025-2.475T12.05 8.5q-1.475 0-2.488 1.025T8.55 12t1.013 2.475T12.05 15.5"
                  />
                </svg>
              </template>

              <v-card
                min-width="300"
                style="background: rgb(34 43 64); border-radius: 1.5rem"
                class="p-4 text-white flex flex-col gap-2"
              >
                <div
                  class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                  @click="
                    open('profile', 2);
                    menu = false;
                  "
                >
                  <div class="flex items-center ml-1">
                    <svg
                      class="mr-2 opacity-80"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M5.85 17.1q1.275-.975 2.85-1.537T12 15t3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4T6.337 6.338T4 12q0 1.475.488 2.775T5.85 17.1M12 13q-1.475 0-2.488-1.012T8.5 9.5t1.013-2.488T12 6t2.488 1.013T15.5 9.5t-1.012 2.488T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
                      />
                    </svg>
                    <span class="text-sm font-semibold">Profil</span>
                  </div>
                  <div class="flex gap-2"></div>
                </div>
                <v-menu v-model="menu2" :close-on-content-click="false" location="start top">
                  <template v-slot:activator="{props}">
                    <div
                      class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                      v-bind="props"
                    >
                      <div class="flex items-center ml-1">
                        <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                          <span class="w-3 rounded-full h-3" :style="`background:${statusColors[myStatusRef]}`"></span>
                        </div>
                        <span class="text-sm font-semibold" v-if="myStatusRef == 0">En ligne</span>
                        <span class="text-sm font-semibold" v-if="myStatusRef == 1">Inactif</span>
                        <span class="text-sm font-semibold" v-if="myStatusRef == 2">Ne pas déranger</span>
                        <span class="text-sm font-semibold" v-if="myStatusRef == 3">Invisible</span>
                      </div>
                      <div class="flex gap-2"></div>
                    </div>
                  </template>

                  <v-card
                    min-width="300"
                    style="background: rgb(34 43 64); border-radius: 1.5rem; backdrop-filter: blur(10px)"
                    class="p-4 text-white flex flex-col gap-2"
                  >
                    <div
                      @click="changeStatus(0)"
                      class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                    >
                      <div class="flex items-center ml-1">
                        <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                          <span class="w-3 rounded-full h-3 bg-[lightgreen]"></span>
                        </div>
                        <span class="text-sm font-semibold">En ligne</span>
                      </div>
                      <div class="flex gap-2"></div>
                    </div>
                    <div
                      @click="changeStatus(1)"
                      class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                    >
                      <div class="flex items-center ml-1">
                        <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                          <span class="w-3 rounded-full h-3 bg-[#ffaf00]"></span>
                        </div>
                        <span class="text-sm font-semibold">Inactif</span>
                      </div>
                      <div class="flex gap-2"></div>
                    </div>
                    <div
                      @click="changeStatus(2)"
                      class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                    >
                      <div class="flex items-center ml-1">
                        <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                          <span class="w-3 rounded-full h-3 bg-[#f54f67]"></span>
                        </div>
                        <span class="text-sm font-semibold">Ne pas déranger</span>
                      </div>
                      <div class="flex gap-2"></div>
                    </div>
                    <div
                      @click="changeStatus(3)"
                      class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                    >
                      <div class="flex items-center ml-1">
                        <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                          <span class="w-3 rounded-full h-3 bg-[gray]"></span>
                        </div>
                        <span class="text-sm font-semibold">Invisible</span>
                      </div>
                      <div class="flex gap-2"></div>
                    </div>
                  </v-card>
                </v-menu>
                <!-- <div
                  class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                  @click="logout()"
                >
                  <div class="flex items-center ml-1">
                    <svg
                      class="mr-2 text-[#f54f67]"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M4 5.4A1.4 1.4 0 0 1 5.4 4h6.2A1.4 1.4 0 0 1 13 5.4V8a1 1 0 1 0 2 0V5.4A3.4 3.4 0 0 0 11.6 2H5.4A3.4 3.4 0 0 0 2 5.4v13.2A3.4 3.4 0 0 0 5.4 22h6.2a3.4 3.4 0 0 0 3.4-3.4V16a1 1 0 1 0-2 0v2.6a1.4 1.4 0 0 1-1.4 1.4H5.4A1.4 1.4 0 0 1 4 18.6z"
                      />
                      <path
                        fill="currentColor"
                        d="M17.293 8.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L18.586 13H7a1 1 0 1 1 0-2h11.586l-1.293-1.293a1 1 0 0 1 0-1.414"
                      />
                    </svg>
                    <span class="text-sm font-bold text-[#f54f67]">Se déconnecter</span>
                  </div>
                  <div class="flex gap-2"></div>
                </div> -->
              </v-card>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
  </div>

  <BottomSheet
    :snapPoints="[maxHeight]"
    :blocking="false"
    ref="bottomSheet"
    @closed="detectclose(2)"
    :default-snap-point="maxHeight"
    :can-swipe-close="swipeClose"
  >
    <ProfileView
      v-if="showBottomSheetToggleProfile && urlProfile != 'settings'"
      ref="profile"
      :url="urlProfile"
      :key="urlProfile"
      @change-url="open"
    />
    <SettingsView v-if="showBottomSheetToggleProfile && urlProfile == 'settings'" />
  </BottomSheet>
  <BottomSheet
    :snapPoints="[maxHeight]"
    :blocking="false"
    ref="bottomSheet2"
    @closed="detectclose()"
    :default-snap-point="maxHeight"
    :can-swipe-close="swipeClose"
  >
    <InfoAnime v-if="showBottomSheetToggle" ref="infoAnime" :url="url" :key="url" @change-url="changeUrl" />
  </BottomSheet>
  <BottomSheet
    :snapPoints="[maxHeight]"
    :blocking="false"
    ref="bottomSheet3"
    @closed="detectclose(1)"
    :default-snap-point="maxHeight"
    :can-swipe-close="swipeClose"
  >
    <Ranked v-if="showBottomSheetToggleRanked" ref="ranked" />
  </BottomSheet>
</template>
<script setup>
  import {ref, reactive, onMounted, watch} from "vue";
  import {useGlobalStore} from "@/stores/global";
  import {useRouter} from "vue-router";
  import {useJoinRoomStore} from "@/stores/joinRoom";
  import {useAuthStore} from "@/stores/auth";
  import {useFetch} from "@vueuse/core";
  import Ranked from "./RankedView.vue";
  import InfoAnime from "./TestInfoAnime.vue";
  import BottomSheet from "@douxcode/vue-spring-bottom-sheet";
  import "@douxcode/vue-spring-bottom-sheet/dist/style.css";
  import {Swiper, SwiperSlide} from "swiper/vue";
  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/virtual";
  import {Navigation, Virtual} from "swiper/modules";
  import ProfileView from "./TestProfileView.vue";
  import FriendsView from "./FriendsView.vue";
  import SettingsView from "./TestSettingsView.vue";
  import RegisterView from "./RegisterView.vue";
  const selectedLanguage = ref(localStorage.getItem("lang"));
  const langs = ref([
    {title: "English", iso: "en"},
    {title: "Français", iso: "fr"},
    {title: "Español", iso: "es"},
    {title: "Deutsch", iso: "de"},
    {title: "Italiano", iso: "it"},
    {title: "Português", iso: "pt"},
    {title: "Polski", iso: "pl"},
    {title: "Русский", iso: "ru"},
    {title: "日本語", iso: "ja"},
  ]);
  const statusColors = ["#90ee90", "#ffaf00", "#f54f67", "#808080"];
  const userStatuses = ref({});
  const url = ref(null);
  const menu = ref(false);
  const menu2 = ref(false);
  const tab = ref(0);
  const choose = ref(0);
  const persistentRegister = ref(false);
  const urlProfile = ref(null);
  const modules = [Navigation, Virtual];
  const loadSearch = ref(false);
  const persistentRef = ref(false);
  const swipeClose = ref(true);
  const bottomSheet = ref(null);
  const bottomSheet2 = ref(null);
  const bottomSheet3 = ref(null);
  const maxHeight = ref(window.innerHeight);
  let stopPropa = true;
  let backdrop;
  const matchFound = ref(false);
  const confirmLeave = ref(false);
  const countdown = ref(5);
  const auth = useAuthStore();
  const joinRoom = useJoinRoomStore();
  const socket = joinRoom.socket;
  const global = useGlobalStore();
  const router = useRouter();
  const settings = reactive({
    n: 1,
    songsNumber: 20,
    difficulty: 7,
    songsSelection: false,
    access: false,
    nextSong: [],
  });
  const query = ref("");
  const toggleSettingsSearch = ref(false);
  const servSearch = ref(false);
  const loading = ref(false);
  const settingsSearch = reactive({
    genre: null,
    studio: null,
    origine: null,
    format: null,
    saison: null,
    annee: [1961, new Date().getFullYear() + 1],
    sorted: "Pertinence",
    desc: false,
  });
  // Options de sélection
  const genres = [
    "action",
    "drame",
    "thriller",
    "shonen",
    "aventure",
    "comedie",
    "fantastique",
    "mystere",
    "sci_fi",
    "romance",
    "ecchi",
    "shojo",
    "sport",
    "supernatural",
    "tranche_de_vie",
    "seinen",
    "horreur",
    "erotique",
    "josei",
    "isekai",
    "surnaturel",
    "nekketsu",
    "psychologique",
    "historique",
    "mecha",
    "hentai",
  ];
  const studios = [
    "81 Produce",
    "10Gauge",
    "7doc",
    "100studio",
    "5 Inc.",
    "1IN",
    "3xCube",
    "33 Collective",
    "Aniplex",
    "ADV Films",
    "AIC",
    "A-1 Pictures",
    "AQUA ARIS",
    "Ashi Productions",
    "Actas",
    "Asahi Production",
    "Artland",
    "Alpha Group",
    "A.C.G.T.",
    "AIC ASTA",
    "Artmic",
    "Ai Addiction",
    "Animation Do",
    "APPP",
    "Alpha Animation",
    "AIC PLUS+",
    "AT-2",
    "arma bianca",
    "Akatsuki",
    "Ascendent Animation",
    "Ascension",
    "AXsiZ",
    "Asura Film",
    "Agent 21",
    "AIC Build",
    "Animaruya",
    "ARCUS",
    "ADK Emotions NY Inc.",
    "Acca effe",
    "ABC Frontier",
    "Animation Staff Room",
    "AIC Classic",
    "A-Real",
    "ACC Production",
    "A-Line",
    "Anon Pictures",
    "Anpro",
    "Andraft",
    "Au Praxinoscope",
    "Atelier Pontdarc",
    "Anima&Co.",
    "AC-Bu",
    "ARECT",
    "Anime Friend",
    "Arch",
    "AION Studio",
    "Ai Yume Mai",
    "Aiti St.",
    "Alfred Imageworks",
    "Alice Production",
    "Arcturus",
    "An DerCen",
    "Alke",
    "Anime Tokyo",
    "Aurora Animation",
    "Animation 501",
    "AIC Project",
    "ANiMix Project",
    "Atti Production",
    "Atorie A.B.C.",
    "Amineworks",
    "Amarcord",
    "Aiko",
    "Alpha Pictures",
    "Animation Lab Japan",
    "Ark",
    "Albacrow",
    "ANIDO FILM",
    "Ankama Animations",
    "Aurum Production",
    "Arcs Create",
    "AIC Takarazuka",
    "bilibili",
    "Bandai Entertainment",
    "Brain's Base",
    "BS Fuji",
    "Bandai Namco Music Live",
    "BS NTV",
    "Blue bread",
    "Bridge",
    "B.CMAY PICTURES",
    "Bandai Visual USA",
    "Big Firebird Culture",
    "Bouncy",
    "Bibury Animation Studios",
    "BYMENT",
    "Blue Cat",
    "BOMB! CUTE! BOMB!",
    "BS TV Tokyo",
    "Bakken Record",
    "BUG FILMS",
    "Boyan Pictures",
    "B&T",
    "Buemon",
    "Bebow",
    "Big Wing",
    "Bibury Animation CG",
    "Borutong",
    "Bellnox Films",
    "Blaze Studio",
    "Big Pine Animation Studio",
    "Bigcat Studio",
    "Blue Moon Studio Inc.",
    "Blue Note",
    "Benlai Pictures",
    "Brio Animation",
    "Beijing Sunchime Happy Culture Company",
    "Bitgang",
    "Bianyue Culture",
    "Beijing Rocen Digital",
    "Creators in Pack",
    "Crunchyroll SC Anime Fund",
    "C2C",
    "C-Station",
    "CygamesPictures",
    "Collaboration Works",
    "Craftar Studios",
    "CHOCOLATE",
    "CLAP",
    "Cloud Hearts",
    "Chiptune",
    "Creative Power Entertaining",
    "Coastline Animation Studio",
    "CUKA",
    "CMC Media",
    "CUCURI",
    "CANON RECORDINGS",
    "cogitoworks",
    "Cafe de Jeilhouse",
    "Creators Dot Com",
    "Cocktail Media",
    "Creative House Pocket",
    "CUC Anima",
    "CD Projekt Red",
    "Circus Production",
    "Cutie Bee",
    "Circle Tribute",
    "CinePix",
    "C&S Production",
    "C and R",
    "Concept Films",
    "Chimu Jika Hatsuden",
    "Discotek Media",
    "DLE",
    "David Production",
    "Disney Platform Distribution",
    "DMM.futureworks",
    "Dongwoo A&E",
    "DandeLion Animation Studio",
    "Decovocal",
    "Daewon Media",
    "Dream Entertainment",
    "Dynamo Pictures",
    "Dangun Pictures",
    "DC Impression Vision",
    "DR Movie",
    "DiC Entertainment",
    "Datama Film",
    "Dancing CG Studio",
    "Digital Network Animation",
    "D.ROCK-ART",
    "Dazzling Star",
    "drop",
    "Dyna Method",
    "Djinn Power",
    "Diwphalanx Records",
    "Dongyang Animation",
    "Dai-Ichi Douga",
    "D'ART Shtajio",
    "Daysview Animation",
    "Delpic",
    "Days",
    "Drawing and Manual",
    "Dawn Animation",
    "Da Huoniao Donghua",
    "Eiken",
    "Echoes",
    "E&G Films",
    "ENGI",
    "Encourage Films",
    "EDGE",
    "Enishiya",
    "Eallin",
    "Emon",
    "East Fish Studio",
    "Elias",
    "EKACHI EPILKA",
    "Ekura Animal",
    "Egg",
    "Escape Velocity Animation",
    "Enjin Productions",
    "Ezόla",
    "Executive Decision",
    "Eshoya Honpo",
    "evg",
    "Enzo Animation",
    "Ekakiya",
    "Ether Kitten",
    "e-notion",
    "Ezo Kobo",
    "feel.",
    "Fanworks",
    "Flat Studio",
    "Fenz",
    "Felix Film",
    "Fuji Creative",
    "Front Line",
    "Fever Creations",
    "flag Co.",
    "FUNNY MOVIE",
    "Geneon Entertainment USA",
    "Gonzo",
    "Group TAC",
    "Geidai Animation",
    "Gainax",
    "Geneon Universal Entertainment",
    "Gathering",
    "Green Bunny",
    "Graphinica",
    "GANSIS",
    "Geek Toys",
    "Good Smile Film",
    "Garden Culture",
    "G-angle",
    "Geno Studio",
    "Grouper Productions",
    "G-Lam",
    "Gravity Well",
    "GIFTanimation",
    "GEMBA",
    "GARDEN LODGE",
    "Giga Production",
    "G.P Entertainment",
    "Gainax Kyoto",
    "GRIZZLY",
    "G&G Direction",
    "Ginga Teikoku",
    "Garyuu Studio",
    "Ga-Crew",
    "Gambit",
    "Green Monster Team",
    "Guton Animation Studio",
    "GUMBLAB",
    "Griot Groove",
    "Gunners",
    "Gonzino",
    "GAV Video",
    "Gosay Studio",
    "Grom",
    "Haoliners Animation League",
    "Hoods Entertainment",
    "Happinet Phantom Studios",
    "High Energy Studio",
    "Horgos Coloroom Pictures Co., Ltd.",
    "Hayabusa Film",
    "Horannabi",
    "HS Pictures Studio",
    "Hand to Mouse.",
    "Husio Studio",
    "HM Heros",
    "Hu Po Donghua",
    "Hifumi Shobo",
    "happyproject",
    "Hai An Xian Donghua Gongzuo Shi",
    "helo.inc",
    "Hanjin Animation",
    "iQIYI",
    "ILCA",
    "Iconix Entertainment",
    "Ijigen Tokyo",
    "Imagin",
    "IMAGICA Lab.",
    "Imagica Infos",
    "Imagineer",
    "I.Gzwei",
    "Image House",
    "Issen",
    "iDreamSky",
    "Inugoya",
    "iDRAGONS Creative Studio",
    "Ishimori Entertainment",
    "Imagestone Inc.",
    "Infinity Vision",
    "Imagica Digitalscape",
    "Ishibashi Planning",
    "IKK Room",
    "Imagica Imageworks",
    "Madhouse",
    "MAPPA",
    "Mushi Production",
    "Production I.G",
    "Pierrot",
    "OLM",
    "Sunrise",
    "Studio Deen",
    "Shin-Ei Animation",
    "Kyoto Animation",
    "A-1 Pictures",
    "Trigger",
    "Ufotable",
  ];
  const origines = [
    "Manga",
    "Light Novel",
    "Web manga",
    "Web novel",
    "Jeu video",
    "4-koma manga",
    "Book",
    "Card game",
    "Mixed media",
    "Music",
    "Novel",
    "Oeuvre original",
    "Picture book",
    "Radio",
    "Visual novel",
  ];
  const formats = ["TV", "Film", "OAV", "ONA", "Special", "TV Special", "PV", "Music", "CM"];
  const sorted = ["Pertinence", "Ordre alphabétique", "Popularité", "Date"];
  const tickLabels = ref({
    0: "All",
    1: "Winter",
    2: "Spring",
    3: "Summer",
    4: "Fall",
  });
  // Réinitialiser les filtres
  const resetFilters = () => {
    Object.keys(settingsSearch).forEach(key => {
      if (key == "annee") {
        settingsSearch[key] = [1961, new Date().getFullYear() + 1];
      } else if (key == "sorted") {
        settingsSearch[key] = "Pertinence";
      } else {
        settingsSearch[key] = null;
      }
    });
  };
  const annuler = () => {
    query.value = "";
    servSearch.value = false;
    toggleSettingsSearch.value = !toggleSettingsSearch.value;
    visibleAnime.value = [];
    visibleAnimeTempo.value = [];
    document.getElementById("searchAnimeHeader").focus();
  };
  function changeUrl(lien) {
    url.value = lien;
  }
  async function logout() {
    await useFetch("https://api.baranimes.com/api/logout", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
    });
    location.reload();
  }

  function searchFocus() {
    setTimeout(function () {
      document.querySelector(".v-overlay-container .v-overlay").style.zIndex = 3200;
      document.getElementById("searchAnimeHeader").focus();
    }, 1);
  }
  const visibleAnime = ref([]);
  const visibleAnimeTempo = ref([]);
  // const fullScreen = ref(false);
  const animesSongs = ref([]);
  const showBottomSheetToggle = ref(false);
  const showBottomSheetToggleRanked = ref(false);
  const showBottomSheetToggleProfile = ref(false);
  const audio = new Audio("https://api.baranimes.com/audio/appear.mp3");
  audio.preload = "metadata";
  audio.volume = 0.5;
  audio.currentTime = 1;
  const bass = new Audio("https://api.baranimes.com/audio/bass.mp3");
  bass.preload = "metadata";
  bass.volume = 0.5;
  // bass.currentTime = 1;
  const myStatusRef = ref(0);

  watch(
    () => global.back,
    async value => {
      if (value === true) {
        document.getElementById("home").classList.add("active");
        document.getElementById("back").classList.add("active");
      } else {
        document.getElementById("home").classList.remove("active");
        document.getElementById("back").classList.remove("active");
      }
    }
  );
  onMounted(async () => {
    // const handleCredentialResponse = async response => {
    //   const token = response.credential;
    //   await useFetch("https://api.baranimes.com/api/auth/google", {
    //     method: "post",
    //     credentials: "include",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify({
    //       token,
    //     }),
    //   });
    // };
    // if (auth.user.role == "guest") {
    //   window.google.accounts.id.initialize({
    //     client_id: "203197905550-5ud1bh7hagvdnlpeqgvc82vr0l5qduu3.apps.googleusercontent.com",
    //     callback: handleCredentialResponse,
    //   });
    // }

    const minDistance = 50;
    const maxTime = 500;

    const swipeDiv = document.querySelectorAll("[data-vsbs-scroll]")[0];
    let startY, startTime;

    swipeDiv.addEventListener("touchstart", e => {
      const touch = e.touches[0];
      startY = touch.clientY;
      startTime = new Date().getTime();
    });

    swipeDiv.addEventListener("touchend", e => {
      const touch = e.changedTouches[0];
      const endY = touch.clientY;
      const endTime = new Date().getTime();

      const deltaY = endY - startY;
      const elapsedTime = endTime - startTime;
      if (
        elapsedTime < maxTime &&
        Math.abs(deltaY) > minDistance &&
        document.querySelectorAll("[data-vsbs-scroll]")[0].scrollTop == 0
      ) {
        // Swipe vertical
        if (deltaY > 0) {
          close(2);
        }
      }
    });
    const swipeDiv2 = document.querySelectorAll("[data-vsbs-scroll]")[1];

    swipeDiv2.addEventListener("touchstart", e => {
      const touch = e.touches[0];
      startY = touch.clientY;
      startTime = new Date().getTime();
    });

    swipeDiv2.addEventListener("touchend", e => {
      const touch = e.changedTouches[0];
      const endY = touch.clientY;
      const endTime = new Date().getTime();

      const deltaY = endY - startY;
      const elapsedTime = endTime - startTime;
      if (
        elapsedTime < maxTime &&
        Math.abs(deltaY) > minDistance &&
        document.querySelectorAll("[data-vsbs-scroll]")[1].scrollTop == 0
      ) {
        // Swipe vertical
        if (deltaY > 0) {
          close();
        }
      }
    });
    window.addEventListener("popstate", handleUrlChange);
    document.getElementsByTagName("html")[0].classList.remove("prod");
    document.getElementsByTagName("html")[0].classList.add("dev");
    document.getElementById("logo").classList.add("active");

    // const draggable = document.getElementById("draggable");
    // if (draggable && 1 == 2) {
    //   const {data: response} = await useFetch("https://api.baranimes.com/api/tiktok/get", {
    //     method: "post",credentials: "include",
    //     headers: {
    //       "Content-Type": "application/json",'X-CSRF-Token': auth.user.crsf
    //     },
    //   });
    //   animesSongs.value = JSON.parse(response.value);
    //   var isMouseDown,
    //     initX,
    //     initY,
    //     height = draggable.offsetHeight,
    //     width = draggable.offsetWidth;

    //   draggable.addEventListener("mousedown", function (e) {
    //     isMouseDown = true;
    //     document.body.classList.add("no-select");
    //     initX = e.offsetX;
    //     initY = e.offsetY;
    //   });

    //   document.addEventListener("mousemove", function (e) {
    //     if (isMouseDown) {
    //       var cx = e.clientX - initX,
    //         cy = e.clientY - initY;
    //       if (cx < 0) {
    //         cx = 0;
    //       }
    //       if (cy < 0) {
    //         cy = 0;
    //       }
    //       if (window.innerWidth - e.clientX + initX < width) {
    //         cx = window.innerWidth - width;
    //       }
    //       if (e.clientY > window.innerHeight - height + initY) {
    //         cy = window.innerHeight - height;
    //       }
    //       draggable.style.left = cx + "px";
    //       draggable.style.top = cy + "px";
    //     }
    //   });

    //   draggable.addEventListener("mouseup", function () {
    //     isMouseDown = false;
    //     document.body.classList.remove("no-select");
    //   });
    // }
    backdrop = document.querySelectorAll("[data-vsbs-backdrop]")[1];
    // data.style.visibility = "hidden";

    // showBottomSheetToggle.value = true;
    // bottomSheet.value.open();

    // setTimeout(function () {
    //   bottomSheet.value.close();
    //   setTimeout(function () {
    //     data.style.visibility = "visible";
    //     showBottomSheetToggle.value = false;
    //   }, 400);
    // }, 400);
    global.animesSuggest = [{}, {}, [{}, {}, {}, {}, {}, {}, {}], [{}, {}, {}, {}, {}, {}, {}]];

    const {data: response} = await useFetch("https://api.baranimes.com/api/animes/start", {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": auth.user.crsf,
      },
    });
    const r = JSON.parse(response.value);
    global.animesSuggest = [{}, {}];
    global.animesSuggest = [...global.animesSuggest, ...r];
  });
  onMounted(() => {
    // if (auth.user.role != "guest") {
    //   class Item {
    //     constructor(id, name, quantity = 1) {
    //       this.id = id;
    //       this.name = name;
    //       this.quantity = quantity;
    //     }
    //   }
    //   class Inventory {
    //     constructor(gridElement, size = 25) {
    //       this.grid = gridElement;
    //       this.slots = Array(size).fill(null);
    //       this.lastTouch = {x: 0, y: 0};
    //       this.currentDrag = null;
    //       this.init();
    //     }
    //     init() {
    //       this.grid.innerHTML = "";
    //       this.slots.forEach((_, index) => {
    //         const slot = document.createElement("div");
    //         slot.className = "slot";
    //         slot.dataset.index = index;
    //         var div = document.getElementById("logo");
    //         let dataVValue;
    //         for (var key in div.dataset) {
    //           dataVValue = key;
    //         }
    //         slot.setAttribute("data-v" + dataVValue.substring(1), "");
    //         slot.addEventListener("dragover", e => this.handleDragOver(e));
    //         slot.addEventListener("drop", e => this.handleDrop(e));
    //         this.grid.appendChild(slot);
    //       });
    //     }
    //     addItem(item) {
    //       const emptySlot = this.slots.findIndex(slot => slot === null);
    //       if (emptySlot !== -1) {
    //         this.slots[emptySlot] = item;
    //         this.updateDisplay();
    //         return true;
    //       }
    //       return false;
    //     }
    //     handleDragOver(e) {
    //       e.preventDefault();
    //     }
    //     handleDrop(e) {
    //       e.preventDefault();
    //       if (!e.dataTransfer.getData("text").trim()) return;
    //       const data = JSON.parse(e.dataTransfer.getData("text"));
    //       const fromIndex = data.index;
    //       const fromInventory = window[data.inventoryId];
    //       const slot = e.target.closest(".slot");
    //       if (!slot) return;
    //       const toIndex = parseInt(slot.dataset.index);
    //       const toInventory = this;
    //       this.swapItems(fromInventory, fromIndex, toInventory, toIndex);
    //     }
    //     handleDragStart(e, index) {
    //       e.dataTransfer.setData(
    //         "text",
    //         JSON.stringify({
    //           index: index,
    //           inventoryId: this.grid.id,
    //         })
    //       );
    //     }
    //     handleTouchStart(e, index) {
    //       e.preventDefault();
    //       const touch = e.touches[0];
    //       this.currentDrag = {
    //         inventoryId: this.grid.id,
    //         index: index,
    //         element: e.target.cloneNode(true),
    //       };
    //       const clone = this.currentDrag.element;
    //       clone.classList.add("item-drag-clone");
    //       clone.style.position = "fixed";
    //       clone.style.left = `${touch.pageX}px`;
    //       clone.style.top = `${touch.pageY}px`;
    //       document.body.appendChild(clone);
    //       const moveHandler = moveEvent => {
    //         const touch = moveEvent.touches[0];
    //         clone.style.left = `${touch.pageX}px`;
    //         clone.style.top = `${touch.pageY}px`;
    //         this.lastTouch.x = touch.clientX;
    //         this.lastTouch.y = touch.clientY;
    //       };
    //       const endHandler = () => {
    //         document.removeEventListener("touchmove", moveHandler);
    //         document.removeEventListener("touchend", endHandler);
    //         document.removeEventListener("touchcancel", endHandler);
    //         const element = document.elementFromPoint(this.lastTouch.x, this.lastTouch.y);
    //         const slot = element?.closest(".slot");
    //         if (slot) {
    //           const toInventory = window[slot.closest(".grid").id];
    //           const toIndex = parseInt(slot.dataset.index);
    //           this.lastTouch = {x: 0, y: 0};
    //           if (this.currentDrag) {
    //             const fromInventory = window[this.currentDrag.inventoryId];
    //             fromInventory.swapItems(fromInventory, this.currentDrag.index, toInventory, toIndex);
    //           }
    //         }
    //         clone.remove();
    //         this.currentDrag = null;
    //       };
    //       document.addEventListener("touchmove", moveHandler);
    //       document.addEventListener("touchend", endHandler);
    //       document.addEventListener("touchcancel", endHandler);
    //     }
    //     swapItems(fromInventory, fromIndex, toInventory, toIndex) {
    //       const fromItem = fromInventory.slots[fromIndex];
    //       const toItem = toInventory.slots[toIndex];
    //       if (!fromItem) return;
    //       // Échange les items
    //       fromInventory.slots[fromIndex] = toItem;
    //       toInventory.slots[toIndex] = fromItem;
    //       fromInventory.updateDisplay();
    //       toInventory.updateDisplay();
    //     }
    //     updateDisplay() {
    //       this.grid.querySelectorAll(".slot").forEach((slot, index) => {
    //         slot.innerHTML = "";
    //         const item = this.slots[index];
    //         if (item) {
    //           const itemElement = document.createElement("div");
    //           itemElement.className = "item";
    //           var div = document.getElementById("logo");
    //           let dataVValue;
    //           for (var key in div.dataset) {
    //             dataVValue = key;
    //           }
    //           itemElement.setAttribute("data-v" + dataVValue.substring(1), "");
    //           itemElement.draggable = true;
    //           itemElement.textContent = item.name[0];
    //           itemElement.addEventListener("dragstart", e => this.handleDragStart(e, index));
    //           itemElement.addEventListener("touchstart", e => this.handleTouchStart(e, index));
    //           // Gestion unifiée du transfert
    //           const transferHandler = e => {
    //             e.preventDefault();
    //             let now = Date.now();
    //             if (now - (this.lastTransferTap || 0) < 200) {
    //               this.transferItem(index);
    //               this.lastTransferTap = 0;
    //             } else {
    //               this.lastTransferTap = now;
    //             }
    //           };
    //           itemElement.addEventListener("click", transferHandler);
    //           itemElement.addEventListener("touchend", transferHandler);
    //           const quantity = document.createElement("div");
    //           quantity.className = "quantity";
    //           quantity.setAttribute("data-v" + dataVValue.substring(1), "");
    //           quantity.textContent = item.quantity;
    //           itemElement.appendChild(quantity);
    //           slot.appendChild(itemElement);
    //         }
    //       });
    //     }
    //     transferItem(index) {
    //       const item = this.slots[index];
    //       if (!item) return;
    //       const otherInventory = this.grid.id === "playerInventory" ? chestInventory : playerInventory;
    //       const emptySlot = otherInventory.slots.findIndex(slot => slot === null);
    //       if (emptySlot !== -1) {
    //         otherInventory.slots[emptySlot] = item;
    //         this.slots[index] = null;
    //         this.updateDisplay();
    //         otherInventory.updateDisplay();
    //       }
    //     }
    //   }
    //   // Initialisation
    //   const playerInventory = new Inventory(document.getElementById("playerInventory"), 5);
    //   const chestInventory = new Inventory(document.getElementById("chestInventory"));
    //   // Ajout d'objets de test
    //   playerInventory.addItem(new Item(1, "Épée"));
    //   playerInventory.addItem(new Item(2, "Bouclier"));
    //   playerInventory.addItem(new Item(3, "Potion", 3));
    //   chestInventory.addItem(new Item(4, "Clé"));
    //   chestInventory.addItem(new Item(5, "Parchemin", 2));
    //   window.playerInventory = playerInventory;
    //   window.chestInventory = chestInventory;
    // }
  });
  const open = (link, ranked) => {
    if (showBottomSheetToggleRanked.value) {
      return;
    }
    if (showBottomSheetToggle.value && !ranked) {
      persistentRef.value = false;
      changeUrl(link);
      return;
    }
    if (showBottomSheetToggleProfile.value && ranked == 2 && !showBottomSheetToggle.value) {
      urlProfile.value = link;
      return;
    } else if (showBottomSheetToggleProfile.value && ranked == 2 && showBottomSheetToggle.value) {
      urlProfile.value = link;
      close();
      return;
    }
    maxHeight.value = window.innerHeight;
    // document.querySelectorAll("[data-vsbs-scroll]").scrollTop = 0;
    const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    if (!hasTouch) {
      swipeClose.value = false;
      // setTimeout(function () {
      //   document.querySelectorAll("[data-vsbs-header]").style.display = "none";
      //   document.querySelectorAll("[data-vsbs-shadow]").style.borderRadius = 0;
      // }, 1);
    }
    global.back = true;
    document.getElementById("back").classList.add("active");
    backdrop.style.display = "block";
    setTimeout(function () {
      backdrop.style.opacity = 1;
    }, 1);
    document.getElementById("main").style.zIndex = 3001;

    if (ranked == 1) {
      showBottomSheetToggleRanked.value = true;
      bottomSheet3.value.open();
      setTimeout(function () {
        document.querySelectorAll("[data-vsbs-header]")[2].style.display = "none";
        document.querySelectorAll("[data-vsbs-shadow]")[2].style.borderRadius = 0;
      }, 1);
    } else if (ranked == 2) {
      if (showBottomSheetToggle.value) {
        close();
      }
      showBottomSheetToggleProfile.value = true;
      urlProfile.value = link;
      persistentRef.value = false;
      bottomSheet.value.open();
    } else {
      if (persistentRef.value) {
        document.querySelector(".v-overlay-container .v-overlay").style.zIndex = 2400;
      }
      url.value = link;
      showBottomSheetToggle.value = true;
      persistentRef.value = false;
      bottomSheet2.value.open();
    }
  };
  function preRetour() {
    if (showBottomSheetToggleRanked.value) {
      return;
    }
    if (global.step && !showBottomSheetToggle.value && !showBottomSheetToggleProfile.value) {
      history.back();
    } else {
      retour();
    }
  }
  function handleUrlChange() {
    if (global.step) {
      retour();
    }
    if (location.pathname == "/frundefined" || location.pathname == "/enundefined") {
      router.push({name: "testhome"});
    }
  }
  const close = ranked => {
    if (ranked == 1 && showBottomSheetToggleRanked.value) {
      bottomSheet3.value.close();
    } else if (ranked == 2) {
      bottomSheet.value.close();
    } else if (showBottomSheetToggle.value) {
      const swipeDiv = document.querySelectorAll("[data-vsbs-scroll]")[1];
      swipeDiv.removeEventListener("touchend", {});
      swipeDiv.removeEventListener("touchstart", {});
      bottomSheet2.value.close();
    }

    stopPropa = false;

    backdrop.style.opacity = 0;
    setTimeout(function () {
      if (ranked == 1) {
        showBottomSheetToggleRanked.value = false;
        document.getElementById("main").style = "";
      } else if (ranked == 2) {
        showBottomSheetToggleProfile.value = false;
        document.getElementById("main").style = "";
      } else {
        showBottomSheetToggle.value = false;
        if (!showBottomSheetToggleProfile.value) {
          if (!location.pathname.includes("/testroom")) {
            persistentRef.value = true;
            searchFocus();
          }

          document.getElementById("main").style = "";
        }
      }
      backdrop.style.display = "none";
      if (
        location.pathname == "/fr/testhome" &&
        global.step == 0 &&
        !showBottomSheetToggleRanked.value &&
        !showBottomSheetToggle.value &&
        !showBottomSheetToggleProfile.value
      ) {
        global.back = false;
        document.getElementById("back").classList.remove("active");
      }
      stopPropa = true;
    }, 150);
  };
  function detectclose(ranked) {
    if (
      stopPropa &&
      (showBottomSheetToggle.value || showBottomSheetToggleRanked.value || showBottomSheetToggleProfile.value)
    ) {
      close(ranked);
    }
  }
  function retour() {
    if (showBottomSheetToggle.value || showBottomSheetToggleProfile.value) {
      if (showBottomSheetToggle.value) {
        close();
      } else if (showBottomSheetToggleProfile.value) {
        close(2);
      }
      return;
    }
    if (location.pathname.includes("/testhome")) {
      if (typeof global.pageTransition === "string" && global.step == 0) {
        document.getElementById("controller-box-second").classList.remove("active");
        document.getElementById("controller-box-second-btn").classList.remove("active");
        document.getElementById("controller-box-second-btn-2").classList.remove("active");
        setTimeout(function () {
          router.push({name: global.pageTransition});
        }, 50);
      } else {
        if (global.step == 2) {
          global.step = 1;
          document.getElementById("controller-box-second").classList.remove("next");
          document.getElementById("controller-box-second-btn").classList.remove("next");
          // document.getElementById("controller-box-second-match-top-standard").classList.remove("active");
          document.getElementById("controller-box-second-first").classList.remove("active");
          document.getElementById("controller-box-second-second").classList.remove("active");
          document.getElementById("controller-box-second-btn-2").classList.remove("active");
        } else if (global.step == 3) {
          global.step = 2;
          document.getElementById("controller-box-second-create").classList.remove("active");
          document.getElementById("controller-box-second-first").classList.remove("next");
          document.getElementById("controller-box-second-second").classList.remove("next");
        } else {
          global.step = 0;
          global.back = false;
          document.getElementById("back").classList.remove("active");
          document.getElementById("banner-content-main").classList.remove("active");
          document.getElementById("controller-box-second").classList.remove("active");
          document.getElementById("controller-box-second-btn").classList.remove("active");
          setTimeout(function () {
            document.getElementById("controller-box-second").classList.remove("options");
            document.getElementById("controller-box-second-btn").classList.remove("options");
          }, 150);
          setTimeout(function () {
            document.getElementById("section-home").classList.remove("active");
            document.getElementById("footer").classList.remove("active");
            // document.getElementById("banner-left-vertical-main").classList.remove("active");
          }, 100);
          // window.history.pushState({}, "", window.location.pathname);
        }
      }
    } else if (location.pathname == "/fr/testroom" || location.pathname == "/fr/ascension") {
      confirmLeave.value = true;
    } else if (
      location.pathname == "/fr/testbattle-pass" ||
      location.pathname == "/fr/teststore" ||
      location.pathname == "/fr/testavatar"
    ) {
      global.back = false;
      global.pageTransition = 2;
      document.getElementsByTagName("body")[0].classList.add("maxHeight");
      document.getElementById("router").classList.add("translateY");
      document.getElementById("router").classList.add("test");
      document.getElementById("logo").classList.add("active");
      setTimeout(function () {
        router.push({name: "testhome"});
      }, 50);
    } else {
      global.back = false;
      router.push({name: "testhome"});
    }
  }
  // function play() {
  //   if (location.pathname == "/fr/testbattle-pass" || location.pathname == "/fr/teststore") {
  //     global.pageTransition = location.pathname.replace("/en/", "").replace("/fr/", "").replace("-", "");
  //     global.step = 0;
  //     document.getElementsByTagName("body")[0].classList.add("maxHeight");
  //     document.getElementById("router").classList.add("translateY");
  //     document.getElementById("router").classList.add("test");
  //     setTimeout(function () {
  //       router.push({name: "testhome"});
  //       document.getElementById("logo").classList.add("active");
  //     }, 100);
  //   }
  // }
  const search = () => {
    loadSearch.value = true;
    if (!servSearch.value) {
      socket.emit("search", query.value, choose.value);
    }
  };
  const searchFocusIn = () => {
    if (servSearch.value) {
      toggleSettingsSearch.value = true;
    }
  };
  const settingsSearchFunc = () => {
    loading.value = true;
    servSearch.value = true;
    socket.emit("settingsSearch", query.value, settingsSearch);
  };
  const setSongsNumber = () => {
    if (settings.nextSong.length) {
      for (let i = 0; i < settings.n; i++) {
        settings.nextSong.unshift({});
      }
    }
    socket.emit("settings", settings);
  };
  function groupArray(arr) {
    const itemWidth = 184;
    const itemMargin = 30;
    const totalItemWidth = itemWidth + itemMargin;
    let size = Math.floor(window.innerWidth / totalItemWidth) || 1;
    size > 7 ? (size = 7) : null;
    let result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  // Recalculer la taille du groupe lors du redimensionnement de la fenêtre
  window.addEventListener("resize", () => {
    visibleAnime.value = groupArray(visibleAnimeTempo.value);
  });
  const changeStatus = myStatus => {
    myStatusRef.value = myStatus;
    socket.emit("updateStatus", myStatus, location.pathname);
  };
  socket.on("updateStatus", myStatus => {
    myStatusRef.value = myStatus;
    socket.emit("updateStatus", myStatusRef.value, location.pathname);
  });
  socket.on("statusUpdated", status => {
    userStatuses.value = status;
  });

  socket.on("search", function (response) {
    visibleAnimeTempo.value = response;
    visibleAnime.value = groupArray(response);
    loadSearch.value = false;
  });
  socket.on("settingsSearch", function (response) {
    visibleAnimeTempo.value = response;
    visibleAnime.value = groupArray(response);
    toggleSettingsSearch.value = false;
    loading.value = false;
  });
  socket.on("matchFound", function (data) {
    audio.play();
    bass.play();
    matchFound.value = true;
    setTimeout(function () {
      document.querySelector(".v-overlay-container .v-overlay").style.zIndex = 9999;
    }, 1);

    const interval = setInterval(() => {
      bass.currentTime = 0;
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(interval);
        document.querySelector(".v-overlay-container .v-overlay").style = "";
        matchFound.value = false;
        open("ranked", 1);
        setTimeout(function () {
          document.querySelectorAll("[data-vsbs-header]")[2].style.display = "none";
          document.querySelectorAll("[data-vsbs-shadow]")[2].style.borderRadius = 0;
        }, 1);
        setTimeout(function () {
          router.push({name: "testroom", query: {id: data}});
          countdown.value = 5;
          audio.pause();
          audio.currentTime = 1;
        }, 150);
        setTimeout(function () {
          if (showBottomSheetToggle.value) {
            close();
          }
          if (showBottomSheetToggleProfile.value) {
            close(2);
          }
        }, 400);
        setTimeout(function () {
          close(1);
        }, 15000);
      }
    }, 1000);
  });
  function formaterDate(dateStr) {
    if (!dateStr) {
      return "Unknown";
    }
    let date = new Date(dateStr);
    let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let options = {timeZone: timeZone, year: "numeric", month: "long", day: "numeric"};
    return new Intl.DateTimeFormat(undefined, options).format(date);
  }
  // var elem = document.documentElement;

  // function openFullscreen() {
  //   fullScreen.value = true;
  //   if (elem.requestFullscreen) {
  //     elem.requestFullscreen();
  //   } else if (elem.webkitRequestFullscreen) {
  //     /* Safari */
  //     elem.webkitRequestFullscreen();
  //   } else if (elem.msRequestFullscreen) {
  //     /* IE11 */
  //     elem.msRequestFullscreen();
  //   }
  // }

  /* Close fullscreen */
  // function closeFullscreen() {
  //   fullScreen.value = false;
  //   if (document.exitFullscreen) {
  //     document.exitFullscreen();
  //   } else if (document.webkitExitFullscreen) {
  //     /* Safari */
  //     document.webkitExitFullscreen();
  //   } else if (document.msExitFullscreen) {
  //     /* IE11 */
  //     document.msExitFullscreen();
  //   }
  // }
  function toggleOutils() {
    document.getElementById("draggable").classList.toggle("invisible");
  }

  const remainingPoints = ref(20);
  const stats = reactive([
    {name: "Vitalité", value: 0},
    {name: "Attaque", value: 0},
    {name: "Défense", value: 0},
    {name: "Puissance", value: 0},
  ]);

  let intervalId = null;
  let timeoutId = null;
  let currentIndex = null;
  let actionType = null;
  const editingIndex = ref(null);
  const tempValue = ref(0);
  const originalValue = ref(0);
  function updatePersistent(val) {
    persistentRegister.value = val;
  }
  function updateStat() {
    if (currentIndex === null || actionType === null) return;

    const stat = stats[currentIndex];

    if (actionType === "increment" && remainingPoints.value > 0) {
      stat.value++;
      remainingPoints.value--;
    } else if (actionType === "decrement" && stat.value > 0) {
      stat.value--;
      remainingPoints.value++;
    }
  }

  function startHold(index, type) {
    currentIndex = index;
    actionType = type;
    updateStat();
    timeoutId = setTimeout(() => {
      intervalId = setInterval(updateStat, 50);
    }, 300);
  }

  function stopHold() {
    clearTimeout(timeoutId);
    clearInterval(intervalId);
    currentIndex = null;
    actionType = null;
  }

  function startEdit(index) {
    editingIndex.value = index;
    originalValue.value = stats[index].value;
    tempValue.value = stats[index].value;
    setTimeout(function () {
      document.getElementById("value-input").focus();
    }, 1);
  }

  function confirmEdit(index) {
    editingIndex.value = index;
    const newValue = Math.max(0, Math.min(parseInt(tempValue.value) || 0, originalValue.value + remainingPoints.value));
    const diff = newValue - originalValue.value;

    if (diff > 0) {
      remainingPoints.value -= diff;
    } else {
      remainingPoints.value += originalValue.value - newValue;
    }
    stats[editingIndex.value].value = newValue;
    editingIndex.value = null;
  }
  defineExpose({open});
</script>
<style scoped>
  .langs.active {
    background: #4b6198;
  }
  #win {
    scrollbar-width: none; /* Firefox */
  }

  #win::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
  #choose span {
    border-radius: 100px;
    width: 92px;
    font-weight: 600;
    height: 33px;
    margin: 0 5px;
    padding: 4px 15px;
    background: hsla(0, 0%, 100%, 0.1);
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #choose span.active {
    background: hsla(0, 0%, 100%, 0.35);
  }
  @keyframes slideInFromTop {
    0% {
      transform: translate(-50%, -200%);
      opacity: 0;
    }
    50% {
      transform: translate(-50%, -150%);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -150%);
      opacity: 0;
    }
  }
  .more {
    width: 23px;
    height: 23px;
    transition: 300ms;
    cursor: pointer;
    border-radius: 9999px;
    position: absolute;
    right: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .line1,
  .line2 {
    width: 12px;
    height: 1.5px;
    position: absolute;
    background: white;
    border-radius: 9999px;
  }
  .line2 {
    rotate: 90deg;
  }
  .coins > div {
    border: 2px solid;
    padding: 4px 24px;
    padding-left: 35px;
    border-radius: 100px;
    position: relative;
    /* background: #1e293bbd; */
  }
  .coins > div > img {
    position: absolute;
    left: -6px;
    height: 36px;
    width: 36px;
  }
  #logo {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    width: 150px;
    opacity: 0;
    transition: 0.2s;
    z-index: 10000;
  }
  #logo.active {
    transform: translate(-50%, -50%);
    opacity: 1;
    transition: 0.4s;
  }
  /* -- Header Section CSS Start -- */

  .custom-container {
    padding: 0 70px 0 32px;
    margin: 0 auto;
  }
  h6 {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 18.48px;
    color: #c7cef8;
  }
  .banner-loop-third .banner-left-vertical-main h6 {
    color: var(--text-color-14);
  }
  .banner-loop-second .banner-left-vertical-main h6 {
    color: var(--text-color-7);
  }
  .banner-left-vertical-main h6 {
    writing-mode: vertical-rl;
    text-orientation: mixed;
  }
  .banner-left-vertical-main img {
    width: 70px;
    height: 70px;
  }
  .banner-left-vertical-main {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .banner-left-vertical-main {
    transition: transform 0.3s, opacity 0.3s;
  }
  .banner-left-vertical-main.active {
    transform: translate(-100%);
  }
  .banner-left-vertical-main.active {
    transition: transform 0.2s, opacity 0.2s;
    opacity: 0;
  }
  #back {
    transition: 0.4s;
    opacity: 0;
    pointer-events: none;
    color: #c7cef8;
  }
  #back.active {
    transition: 0.2s;
    opacity: 0.75;
    pointer-events: all;
  }
  #back.active:hover {
    opacity: 1;
  }
  .header-section-main {
    position: fixed;
    width: 100%;
    z-index: 99;
    height: 0;
    /* box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.3), 0 8px 12px 6px rgba(0, 0, 0, 0.15); */
  }
  /* .header-section-main::before {
    -webkit-backdrop-filter: blur(16px);
    backdrop-filter: blur(16px);
    background-color: rgba(25, 30, 37, 0.8);
    border-radius: 0 0 12px 12px;
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: background-color 0.1s linear;
    z-index: -1;
  } */
  .header-section-inner {
    display: flex;
    justify-content: space-between;
    height: 0;
  }
  .header-logo {
    flex-shrink: 0;
    user-select: none;
    font-weight: 600;
  }
  .header-logo .banner-left-vertical-main {
    justify-content: center;
    height: calc(100vh - 136px);
  }
  .header-logo img {
    width: 60px;
    height: 60px;
  }
  .header-menu ul li svg {
    cursor: pointer;
    /* margin-top: 4px; */
  }
  .header-menu ul {
    justify-content: end;
    list-style: none;
    align-items: center;
    font-weight: 600;
    border-radius: 100px;
    padding: 10px 30px;
    margin-top: -10px;
    /* color: #fff; */
  }

  .header-menu ul li a {
    position: relative;
    font-size: 18px;
    line-height: 20px;
    font-weight: 600;
    font-style: normal;
    color: #c7cef8;
    display: inline-block;
    transition: 0.3s;
    -webkit-transition: 0.3s;
  }
  .header-menu ul li a:hover,
  .header-menu ul li.active a {
    color: #c7cef8;
  }

  .small {
    border: 1px solid rgb(199 206 248 / 50%);
    border-radius: 100%;
  }

  :deep(.rounded-2xl) {
    box-shadow: none;
  }

  .sidebar-right:hover:not(.close),
  .sidebar-right.expanded {
    width: 400px;
    overflow: visible;
  }
  .sidebar-right:hover:not(.close) .child,
  .sidebar-right.expanded .child {
    min-width: 0;
    opacity: 0;
  }

  .sidebar-right {
    background: hsl(0deg 0% 0% / 32%);
    backdrop-filter: blur(10px);
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100%;
    color: white;
    right: 0;
    width: 56px;
    transition: width 0.2s ease;
    z-index: 1000;
    overflow-y: auto !important;
  }
  .sidebar-right::-webkit-scrollbar {
    display: none;
  }
  .play.play2 {
    animation: quickPlayButtonEffect 5s infinite linear;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background: linear-gradient(
      -60deg,
      #ff8d9e,
      #ff8d9e 10%,
      #f54f67 25%,
      #f54f67 30%,
      #ff8d9e 50%,
      #f54f67 80%,
      #f54f67 85%,
      #ff8d9e 92%
    );
    cursor: pointer;
    color: #fff;
    background-size: 200% 100%;
    border-radius: 24px;
    padding: 9px 24px;
    padding-bottom: 12px;
    font-weight: 700;
  }
  .match-found {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background: linear-gradient(
      -60deg,
      #ff8d9e 0%,
      #ff8d9e 10%,
      #f54f67 25%,
      #f54f67 30%,
      #ff8d9e 50%,
      #f54f67 80%,
      #f54f67 85%,
      #ff8d9e 92%
    );
    cursor: pointer;
    color: white;
    animation: quickPlayButtonEffect 15s infinite linear;
    background-size: 200% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @keyframes quickPlayButtonEffect {
    100% {
      background-position-x: -200%;
    }
  }

  /* -- Header Section CSS End -- */
  #draggable {
    background: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    font-size: 2rem;
    z-index: 10000;
    color: black;
    border-radius: 1rem;
    user-select: none;
    flex-direction: column;
    max-width: 600px;
  }
  .container {
    max-width: 800px;
    margin: 20px auto;
    padding: 0 20px;
  }

  .stat-container {
    padding: 10px 20px;
    border-radius: 10px;
  }

  .stat {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  .stat-name {
    width: 120px;
    font-weight: bold;
  }

  .stat-value {
    margin: 0 15px;
    min-width: 30px;
    text-align: center;
    font-size: 1.2em;
    width: 60px;
  }

  .container button {
    padding: 8px 15px;
    font-size: 1.1em;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    transition: all 0.2s;
  }

  .btn-increment {
    background-color: #4caf50;
    color: white;
  }

  .btn-decrement {
    background-color: #f44336;
    color: white;
  }

  button:hover:not(:disabled) {
    opacity: 0.8;
  }

  button:active:not(:disabled) {
    transform: scale(0.95);
  }

  .points-restants {
    font-size: 1.5em;
    text-align: center;
  }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .value-input {
    width: 60px;
    text-align: center;
    font-size: 1.2em;
    border: 2px solid #ddd;
    border-radius: 4px;
    padding: 2px 5px;
    margin: 0 15px;
  }

  .value-input:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 3px #4caf50;
  }

  .stat-value {
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .stat-value:hover {
    background-color: #f8f8f8;
  }
  .value-input {
    width: 50px;
    text-align: center;
    font-size: 1.2em;
    border: 2px solid #ddd;
    border-radius: 4px;
    padding: 2px 5px;
    margin: 0 15px;
  }

  .value-input:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 3px #4caf50;
  }

  .stat-value {
    cursor: pointer;
    transition: background-color 0.2s;
    padding: 2px 10px;
    border-radius: 4px;
  }

  .stat-value:hover {
    background-color: #f8f8f8;
  }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .inventory {
    border: 2px solid #333;
    padding: 10px;
    background: #444;
    border-radius: 5px;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(5, 50px);
  }

  .slot {
    width: 50px;
    height: 50px;
    border: 1px solid #555;
    background: #666;
    position: relative;
    border-radius: 3px;
  }

  .item {
    width: 100%;
    height: 100%;
    max-width: 50px;
    max-height: 50px;
    background: #3498db;
    position: absolute;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    touch-action: none;
    border-radius: 3px;
  }

  .item-drag-clone {
    opacity: 0.8;
    transform: translate(-50%, -50%);
    z-index: 1000;
    pointer-events: none;
    max-height: 50px;
    height: 50px;
    max-width: 50px;
  }

  .quantity {
    position: absolute;
    bottom: 2px;
    right: 2px;
    color: white;
    font-size: 12px;
  }
  #home {
    transition: 0.3s;
  }
  @media (max-width: 1279px) {
    #back {
      transition: 0.15s;
    }
    #back.active {
      transition: 0.3s;
    }
    #home.active {
      margin-top: -90px;
    }
    #back.active {
      margin-left: -25px;
    }
  }
  :deep(.v-text-field .v-field) {
    border-radius: 10px;
    overflow: hidden;
  }
</style>
